<template>
    <div>
        <div class="p-3 mt-1 mr-1 position-content-main">
            <div class="justify-content-between d-flex header-bottom">
                <div class="breadcrumbnewtheme pb-3">
                    <div class="pre gap-0p5 fw-500">
                        Ticket
                    </div>
                    <span style="color:#b2bec3">/</span>
                    <div class="pre gap-0p5 fw-500">
                        List View
                    </div>
                    <span style="color:#b2bec3">/</span>
                    <span class="curr gap-0p5 fw-500">
                        Create New
                    </span>
                </div>
                <div @click="goTOBack" class="pointer">
                    <img src="/static/images/arrow-left-circle-line.svg" alt="" width="22px">
                    <span class="text-black fw-500 pl-1">Back</span>
                </div>
            </div>
            <div class="general-section pt-2 pb-6">
                <div class="mb-5" style="background:#f0ddb7">
                    <div class="general-section general-box py-4 mt-3 px-0 px-lg-4">
                        <span class="list-text fs-15 fw-600 text-black px-4">1. General Details</span>
                        <div class="row mt-3 px-4">
                            <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                                <div class="w-100">
                                    <div class="d-flex flex-column pt-2" :class="{'justify-content-start': template_type == 'multi_part', 'justify-content-between': template_type == 'default'}">
                                        <label class="inputLabel fs-14 fw-500 text-black">Subject <span class="text-danger"> *</span></label>
                                        <input v-validate="'required'" name="subject" class="inputFieldNew overflowing-text" autocomplete="off" style="padding-right: 30px !important;" type="text" :maxlength="subjectlength" v-model="subject" placeholder="Enter Ticket Subject" />
                                    </div>
                                    <span class="inputBorder"></span>
                                    <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('subject')" style="display: inline !important">{{ errors.first("subject") }}</span>
                                    <span class="pull-right text-right text-black font-600 fs-12 pt-1">{{ subjectlength - subject.length}}/{{subjectlength}}</span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                                <div class="form-group contactGroup pt-0">
                                    <div class="d-flex flex-column pt-2" :class="{'justify-content-start': template_type == 'multi_part', 'justify-content-between': template_type == 'default'}">
                                        <span class="fs-14 fw-500 text-black">
                                            Ticket Template<span class="text-danger"> *</span>
                                        </span>
                                        <div class="d-flex align-items-center mt-4">
                                            <multiselect :title="ticketType.name"
                                                v-model="ticketType" autocomplete="off"
                                                class="diginew-multiselect down-arrow spinner-bg"
                                                :loading="ticket_type_loading"
                                                :options="ticket_type_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                name="ticketType"
                                                :show-labels="false"
                                                @select="selectedTemplate"
                                                @open="getTicketTemplate"
                                                @close="checkTicketType"
                                                @search-change="searchTemplate"
                                                :multiple="false"
                                                :options-limit="3000"
                                                :max-height="200"
                                                v-validate="'required'"
                                                :clear-on-select="false"
                                                label="name" track-by="_id"
                                                :internal-search="false"
                                                :show-no-results="true"
                                                :hide-selected="false"
                                                open-direction="bottom"
                                            >
                                                <template slot="placeholder">
                                                    <span class="diginewhelp-multiselect">Select Ticket Template</span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfTicketTemplate" />
                                                </template>
                                                <template slot="noResult">
                                                    <div v-if="ticket_type_options.length">
                                                        <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-secondary text-center fw-500">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('ticketType')">{{ errors.first("ticketType") }}</span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12" v-if="template_type == 'default'">
                                <div class="form-group contactGroup d-flex flex-column justify-content-between" style="margin-top: 0px;z-index:1 !important;">
                                    <div class="vendor_type d-flex ">
                                        <div class="mr-4 mt-1">
                                        <label class="text-black mr-2 fw-500 fs-14 mb-0" >Assigned to
                                            <span class="text-danger ml-0">*</span>
                                            <span style="position:absolute;top:14px;left:auto; margin-left: -2px;">
                                                <el-tooltip class="item pull-right" effect="dark" content="Employees" placement="top">
                                                    <i class="ri-2x ri-information-line text-black fs-16"></i>
                                                </el-tooltip>
                                            </span>
                                        </label>
                                    </div>
                                    <div class="ml-3">
                                        <el-radio-group class="d-flex align-items-center mt-3 mob-issue-fix" v-model="assignedTo">
                                            <el-tooltip class="item pull-right" v-if="template_type == 'multi_part'" effect="dark" content="A Person cannot be assigned to Multi Part Templates" placement="top">
                                                <el-radio :disabled="template_type == 'multi_part'" @input="assignedToChange()" label="person">
                                                    Person
                                                </el-radio>
                                            </el-tooltip>
                                            <el-radio v-else @input="assignedToChange()" label="person">
                                                Person
                                            </el-radio>
                                            <el-tooltip class="item pull-right" effect="dark" content="Assigning Tickets To Teams Coming Soon" placement="top">
                                                <el-radio disabled @input="assignedToChange()" label="team">
                                                    Team
                                                </el-radio>
                                            </el-tooltip>
                                            <el-radio @input="assignedToChange()" label="unassigned">
                                                Unassigned
                                            </el-radio>
                                        </el-radio-group>
                                    </div>
                                    </div>
                                    <div v-if="assignedTo == 'unassigned'" class="inputFieldNew" style="padding: 12px 11px 8px 8px !important;border-radius: 8px !important;" >
                                        Unassigned
                                    </div>
                                    <multiselect v-else label="name"
                                        v-validate="'required'"
                                        class="diginew-multiselect mt-3 custom-cred-fs"
                                        name="assigned" open-direction="top"
                                        v-model="assignedCustomer" :options-limit="3000"
                                        :max-height="200"
                                        :options="assign_options"
                                        :searchable="true"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :loading="assign_loading" @search-change="getAllAssignTo"
                                    >
                                            <template slot="placeholder">
                                                <span class="diginewhelp-multiselect">Select Name</span>
                                            </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfAssigned" />
                                        </template>
                                        <template slot="noResult">
                                            <div v-if="assign_options.length">
                                                <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div>
                                            </div>
                                            <div v-else class="text-secondary text-center fw-500">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="invalid-feedback-form text-danger mt-0 text-left d-block" style="margin-top:-28px !important" v-show="errors.has('assigned')">{{ errors.first("assigned") }}</span>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 mt-3" v-if="is_approvers_mandatory">
                                <div class="form-group contactGroup pt-2">
                                    <span class="fs-14 fw-500 text-black">
                                        Approver <span class="text-danger"> *</span>
                                    </span>
                                    <div class="d-flex align-items-center mt-3">
                                        <multiselect
                                            v-model="approvers_data" id="ajax" :block-keys="['Tab', 'Enter']"
                                            class="diginew-multiselect overflow-text filter-multiple down-arrow custom-cred-fs"
                                            :class="{'h-100px-ms':approvers_data.length > 2}"
                                            :options="approvers_options"
                                            data-vv-as="Approver" track-by="id"
                                            :searchable="true"
                                            :close-on-select="false"
                                            name="approversData"
                                            :show-labels="false"
                                            :multiple="true"
                                            :options-limit="3000"
                                            :max-height="200"
                                            :min-height="100"
                                            v-validate="is_approvers_mandatory ? 'required' : ''"
                                            :clear-on-select="true"
                                            label="name"
                                            :internal-search="true"
                                            :show-no-results="true"
                                            :allow-empty="true"
                                            :hide-selected="true"
                                            :blockKeys="['Delete']"
                                        >
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag1">
                                                <span class="filterSelectedName1">{{ option.name }}</span>
                                                    <span class="custom__remove pointer">
                                                        <i class="icon icon-close fs-16 text-black" style="display:none"></i>
                                                    </span>
                                                    <span class="custom__remove pointer" @click="removeApprovers(option)">
                                                    <i class="icon icon-close fs-16 text-black"></i>
                                                    </span>
                                                </span>
                                            </template>
                                            <template slot="afterList" v-if="watchApprovers">
                                                <div class="d-flex align-items-center justify-content-center" style="height:40px !important">
                                                    <span class="diginewhelp-multiselect">All the options are selected</span>
                                                </div>
                                            </template>
                                            <template slot="placeholder">
                                                <span class="diginewhelp-multiselect">Select Approvers</span>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-500">No Results Found</div>
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-500">No Options Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('approversData')">{{ errors.first("approversData") }}</span>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="form-group contactGroup" style="margin-top: 0px;z-index:1 !important;height:75%">
                                    <label class="text-black fs-15 fw-500 mr-2">Description</label>
                                    <!-- <textarea rows="5" name="description" placeholder="Enter Description" class="w-100 mt-1 fw-500" style="height:101%;border: 1px solid #676767;border-radius:5px;padding: 5px 10px;" maxlength="1000" v-model="description"></textarea> -->
                                    <vue-editor :counter="200"  @text-change="onTextChange" ref="editor" :editorToolbar="toolbar"
                                    maxlength="1000" name="description" placeholder="Enter Description" class="desc-editor text-black my-2" v-model="description"></vue-editor>
                                    <span class="pull-right text-right text-black font-600 fs-12">{{ 1000 - description.length}}/{{1000}}</span>
                                </div>
                            </div>
                            <div class="mt-2 mx-4">
                                <div class="fs-14 fw-500 mb-5 text-black">
                                        Ticket Priority 
                                        <!-- <span class="text-danger"> *</span> -->
                                </div>
                                <el-radio-group v-model="priority_of_ticket" name="priority_of_ticket"  data-vv-as="Priority Of Ticket">
                                    <div class="d-flex align-items-center">
                                        <div class="eisen-matrix top-left">
                                            <el-radio label="imp_not_urgent">Important - Not Urgent</el-radio>
                                        </div>
                                        <div class="eisen-matrix top-right">
                                            <el-radio label="imp_urgent">Important - Urgent</el-radio>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="eisen-matrix bottom-left">
                                            <el-radio label="not_imp_urgent">Not Important - Urgent</el-radio>
                                        </div>
                                        <div class="eisen-matrix bottom-right">
                                            <el-radio label="not_imp_not_urgent">Not Important - Not Urgent</el-radio>
                                        </div>
                                    </div>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <!-- attachments  v-if="generalActive"-->
                    <div class="general-section general-box py-4 pb-6 mt-3 px-0 px-lg-4" v-if="template_type == 'default' || template_type == 'multi_part'">
                        <!-- <div class="row justify-content-between boxHeader mt-4 py-2" v-if="template_type == 'default' || template_type == 'multi_part'">
                            <div>Ticket Details</div>
                        </div> -->
                        <span class="list-text fs-15 fw-600 text-black px-4">2. Ticket Details</span>
                        <div v-if="template_type == 'multi_part'">
                            <div class="dynamic-section px-5  mt-4 py-4" :class="field_index > 0 && is_approvers_mandatory ? 'bg-grey' : ''" v-for="(field, field_index) in template_details" :key="field_index">
                                <div class="infoHeader mt-2">
                                    <!-- <div class="descriptionheader d-flex justify-content-between">
                                        <div class="description-text-header-left">
                                            <h5 class="font-weight-bold text-black whiteSpace" :title="field.part_name">{{ field.part_name.split('').length > 1 ?  field.part_name[0].toUpperCase() +''+ field.part_name.slice(1,) : field.part_name[0].toUpperCase()}}</h5>
                                        </div>
                                        <div class="description-text-header-right" v-if="is_approvers_mandatory && field_index > 0"></div>
                                        <div class="description-text-header-right" v-else>
                                            <span class="collapse-addon" v-if="field.show">
                                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(field)" alt="" style="top: 9px !important;transition:0.5s">
                                            </span>
                                            <span class="collapse-addon" v-else>
                                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(field)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                            </span>
                                        </div>
                                    </div> -->
                                    <div class="capture-image d-flex align-items-center p-2 px-4">
                                        <span class="text-new-header-black fw-500 mr-3"
                                            style="width: max-content;min-width: max-content;" :title="field.part_name">{{ field.part_name.split('').length > 1 ?  field.part_name[0].toUpperCase() +''+ field.part_name.slice(1,) : field.part_name[0].toUpperCase()}}</span>
                                        <div class="inner-line-hr w-100"></div>
                                        <div v-if="is_approvers_mandatory && field_index > 0"></div>
                                        <div v-else>
                                            <img v-if="field.show" class="pointer capture-image-rotate"
                                            @click="ToggleParts(field)" src="/static/images/etherum-fill.svg" width="24"
                                                height="24">
                                            <img v-else class="pointer capture-image-rotate" @click="ToggleParts(field)"
                                                src="/static/images/new-theme2024/etherum-line.png" width="24" height="24">
                                        </div>
                                    </div>
                                </div>
                                <div class="row px-4" v-if="field.show">
                                    <div class="col-lg-12 col-md-12 col-sm-12" v-for="(td, i) in field.parts_data" :key='i'>
                                        <div class="d-flex flex-column justify-content-start" >
                                            <div class="fw-500 pt-2 pb-2 fs-14 text-black d-inline-block w-100 overflowing-text" :title="td.name">{{td.name.split('').length > 1 ?  td.name[0].toUpperCase() +''+ td.name.slice(1,) : td.name[0].toUpperCase()}}<span class="text-danger" v-if="td.required == true"> *</span></div>
                                            <div>
                                                <!-- Short Answer -->
                                                <input v-if="td.type == 'short_answer'"
                                                class=" inputFieldNew"
                                                style="padding-right: 30px !important;"
                                                type="text"
                                                :disabled="field_index > 0 && is_approvers_mandatory"
                                                v-model="td.answer"
                                                maxlength="100"
                                                placeholder="Enter Short Answer"
                                                :name="'short_answer'+ i + '' +  field_index"
                                                v-validate="td.required ? 'required' : ''"
                                                data-vv-as="Short Answer"
                                                />
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('short_answer'+ i + '' +  field_index)">{{errors.first('short_answer'+ i + '' +  field_index)}}</span>

                                                <!-- API Call Dropdown -->
                                                <div v-if="ticketType.name == 'Digicollect Product Template'">
                                                    <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                        v-model="td.answer"
                                                        class="diginew-multiselect down-arrow mt-3"
                                                        :loading="apicall_loading"
                                                        :options="scm_products_options"
                                                        :disabled="field_index > 0 && is_approvers_mandatory"
                                                        :searchable="true" style="width: 250px !important"
                                                        :close-on-select="true"
                                                        :name="'apidrop_down'+ i + '' +  field_index"
                                                        track-by="_id"
                                                        @close="insertMultiProductTag(td.answer)"
                                                        :show-labels="false"
                                                        @search-change="searchTemplateApiDD"
                                                        @open="getTemplateApiDD"
                                                        :multiple="false"
                                                        :options-limit="3000"
                                                        :max-height="200"
                                                        v-validate="td.required ? 'required' : ''"
                                                        :clear-on-select="false"
                                                        label="name"
                                                        :internal-search="true"
                                                        :show-no-results="true"
                                                        :hide-selected="false"
                                                        >
                                                            <template slot="placeholder">
                                                                <span class="diginewhelp-multiselect">Select Product</span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfApiDD" />
                                                            </template>
                                                            <template slot="noResult">
                                                                <div v-if="scm_products_options.length">
                                                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="text-secondary text-center fw-500">No Results Found</div>
                                                            </template>
                                                    </multiselect>
                                                </div>
                                                <div v-else>
                                                    <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                        v-model="td.answer"
                                                        class="diginew-multiselect down-arrow mt-3"
                                                        :loading="apicall_loading"
                                                        :options="scm_products_options"
                                                        :searchable="true" style="width: 250px !important"
                                                        :disabled="field_index > 0 && is_approvers_mandatory"
                                                        :close-on-select="true"
                                                        :name="'apidrop_down'+ i + '' +  field_index"
                                                        :show-labels="false"
                                                        @search-change="searchApiDD"
                                                        @open="getApiDD"
                                                        @close="insertMultiProductTag(td.answer)"
                                                        :multiple="false"
                                                        :options-limit="3000"
                                                        :max-height="200"
                                                        v-validate="td.required ? 'required' : ''"
                                                        :clear-on-select="false"
                                                        label="name"
                                                        :internal-search="true"
                                                        :show-no-results="true"
                                                        :hide-selected="false"
                                                        >
                                                            <template slot="placeholder">
                                                                <span class="diginewhelp-multiselect">Select Product</span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfApiDD" />
                                                            </template>
                                                            <template slot="noResult">
                                                                <div v-if="scm_products_options.length">
                                                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                        <div></div>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="text-secondary text-center fw-500">No Results Found</div>
                                                            </template>
                                                    </multiselect>
                                                </div>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('apidrop_down'+ i + '' +  field_index)">The Dropdown Field Is Required</span>
                                                <!-- Tags -->
                                                <div v-if="td.type == 'tag'">
                                                    <vue-tags-input :name="'tags'+  i + '' +  field_index"
                                                    data-vv-as="Tags" v-model="td.entered_tag" v-validate="td.required && td.answer.length == 0 ? 'required' : ''" 
                                                    class="multi_part-sec  inputFieldNew-tags create-edit-ticket-tags rel-x2 mt-3" :tags="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                    @tags-changed="tagsChangeMultiData($event, field_index, i, 'by-field')" maxlength="40" 
                                                    :placeholder="ticketType.name == 'Digicollect Product Template' || ticketType.name == 'Product Bug Template' ? 'Add Custom Tags' : 'Enter Tags Here'" 
                                                    id='to_email' :delete-on-backspace="false" />
                                                </div>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('tags'+ i + '' +  field_index)">{{errors.first('tags'+ i + '' +  field_index)}}</span>
                                                <!-- Radiobutton -->
                                                <el-radio-group 
                                                    v-if="td.type == 'radio_button'" class="mt-5 mob-issue-fix w-100" v-model="td.answer" 
                                                    v-validate="td.required ? 'required' : ''" :name="'radio_button'+ i + '' +  field_index" 
                                                    data-vv-as="Radio Button" :disabled="field_index > 0 && is_approvers_mandatory">
                                                    <div class="row">
                                                        <el-radio class="col-xl-2 col-lg-2 col-md-6 col-sm-6 text-capitalize d-flex word-wrap" :label="radio_options" v-for="(radio_options, ri) in td.possible_values" :key="ri">
                                                            {{radio_options}}
                                                        </el-radio>
                                                    </div>
                                                </el-radio-group>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('radio_button'+ i + '' +  field_index)">{{errors.first('radio_button'+ i + '' +  field_index)}}</span>
                                                <!-- Checkbox -->
                                                <el-checkbox-group 
                                                    v-if="td.type == 'check_box'" class="refund-checkbox mt-4 w-100" 
                                                    v-model="td.answer" v-validate="td.required ? 'required' : ''" :name="'check_box'+ i + '' +  field_index" 
                                                    data-vv-as="Check Box" :disabled="field_index > 0 && is_approvers_mandatory">
                                                    <div class="row">
                                                        <el-checkbox class="text-capitalize col-xl-2 col-lg-2 col-md-6 col-sm-6 d-flex word-wrap" :label="check_options" v-for="(check_options, ci) in td.possible_values" :key="ci">
                                                            {{check_options}}
                                                        </el-checkbox>
                                                    </div>
                                                </el-checkbox-group>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('check_box'+ i + '' +  field_index)">{{errors.first('check_box'+ i + '' +  field_index)}}</span>
                                                <!-- Date -->
                                                <date-picker v-if="td.type == 'date'"
                                                    class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor" placeholder="MM/DD/YYYY"
                                                    v-validate="td.required ? 'required' : ''" :disabled="field_index > 0 && is_approvers_mandatory"
                                                    :name="'date'+ i + '' +  field_index"
                                                    data-vv-as="Date" :editable="true"
                                                    value-type="format" onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                                    format="MM/DD/YYYY" type="date" lang="en" v-model="td.answer"
                                                    style="border:none !important">
                                                </date-picker>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date'+ i + '' +  field_index)">{{errors.first('date'+ i + '' +  field_index)}}</span>
                                                <!-- Time -->
                                                <date-picker v-if="td.type == 'time'"
                                                    v-model="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                    style="background: #f1f1f1 !important;"
                                                    format="hh:mm A"
                                                    :name="'time'+ i + '' +  field_index"
                                                    data-vv-as="Time"
                                                    class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon"
                                                    type="time" onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                    placeholder="Enter the time"
                                                    lang="en"
                                                    value-type="format"
                                                    :clearable="false"
                                                    :editable="true"
                                                    @confirm="HandleTimeEventMultiPart($event, field_index, i, 'time')"
                                                    :minute-step="1"
                                                    confirm
                                                    confirm-text="APPLY"
                                                    v-validate="td.required ? 'required' : ''"
                                                ></date-picker>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required && td.answer == ''" v-show="errors.has('time'+ i + '' +  field_index)">{{errors.first('time'+ i + '' +  field_index)}}</span>
                                                <!-- Date and time -->
                                                <div class="d-flex align-items-center" v-if="td.type == 'date_time'">
                                                    <div class="row">
                                                        <date-picker v-if="td.type == 'date_time'"
                                                            class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor col-lg-6 col-md-6 col-sm-12" placeholder="MM/DD/YYYY"
                                                            v-validate="td.required ? 'required' : ''" onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                                            :name="'date_time'+ i + '' +  field_index"
                                                            data-vv-as="Date" :disabled="field_index > 0 && is_approvers_mandatory"
                                                            value-type="format" :editable="true"
                                                            format="MM/DD/YYYY" type="date" lang="en" v-model="td.date"
                                                            style="border:none !important">
                                                        </date-picker>
                                                        <date-picker v-if="td.type == 'date_time'"
                                                            v-model="td.time"
                                                            format="hh:mm a"
                                                            :name="'date_time'+ i + '' +  field_index"
                                                            data-vv-as="Time"
                                                            class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-disabled date-picker-clock-icon col-lg-6 col-md-6 col-sm-12"
                                                            type="time" onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                            placeholder="Enter the time"
                                                            lang="en" :disabled="field_index > 0 && is_approvers_mandatory"
                                                            value-type="format"
                                                            :clearable="false"
                                                            :editable="true"
                                                            :minute-step="1"
                                                            confirm
                                                            @confirm="HandleTimeEventMultiPart($event, field_index, i, 'date_time')"
                                                            confirm-text="APPLY"
                                                            v-validate="td.required ? 'required' : ''"
                                                        ></date-picker>
                                                    </div>
                                                </div>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required && td.date == '' && td.time == ''" v-show="errors.has('date_time'+ i + '' +  field_index)">The Date and Time field required</span>

                                                <!-- Long Answer -->
                                                <textarea 
                                                    placeholder="Enter Long Answer"  maxlength="500" v-validate="td.required ? 'required' : ''" 
                                                    :name="'long_answer'+ i + '' +  field_index" :disabled="field_index > 0 && is_approvers_mandatory" data-vv-as="Long Answer" v-if="td.type == 'long_answer'" v-model="td.answer" 
                                                    class="desc-textarea mt-3"></textarea>
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('long_answer'+ i + '' +  field_index)">{{errors.first('long_answer'+ i + '' +  field_index)}}</span>

                                                <!-- Dropdown -->
                                                <multiselect
                                                    v-if="td.type == 'drop_down' && td.is_api_call_required == false"
                                                    v-validate="td.required ? 'required' : ''" style="width: 250px !important"
                                                    class="diginew-multiselect down-arrow mt-3"
                                                    :name="'drop_down'+ i + '' +  field_index"
                                                    data-vv-as="Drop Down"
                                                    v-model="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                    :options="td.possible_values"
                                                    :searchable="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                >
                                                    <template slot="placeholder">
                                                        <span class="diginewhelp-multiselect">Select Dropdown</span>
                                                    </template>
                                                </multiselect>
                                                <div v-if="td.type == 'location'">
                                                    <div class="digi-table-loader d-flex justify-content-center" v-if="location_loader" id="spinner" style="margin: 0 auto;position:absolute">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                    <div class="form-group contactGroup pt-0 mb-0">
                                                        <div class="d-flex align-items-center">
                                                            <div class="form-group gMap" style="position:relative;width:100%;padding-top:1.3rem !important">
                                                                <!-- <input class="inputFieldNew overflowing-text mt-0 " style="padding-right: 30px !important;" 
                                                                :name="'location' + i + '' +  field_index" type="text" disabled v-model="td.location_details.location_vmodel" 
                                                                placeholder="Enter Location" /> -->
                                                                <!-- id="autocompleteInput"  @place_changed="locationAddress"  name="get_location" :value="location.full_address" -->

                                                                <gmap-autocomplete class="" id="autocompleteInput"  name="get_location"  placeholder="Search Location" @place_changed="locationAddress($event , i)"  :value="td.location_details.location_vmodel"
                                                                    style="padding: 8px 88px 8px 18px !important; height: 40px;background: #f1f1f1; width:100%; border:none !important;"></gmap-autocomplete>
                                                                <div class="d-flex">
                                                                    <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                                </div>
                                                            </div>
                                                            <div v-if="field_index > 0 && is_approvers_mandatory" class="gps-logo" :id="'DisableOnClick' + i + field_index" style="opacity: .5;cursor: not-allowed;">
                                                                <i class="icon-crosshairs-gps color-blue" ></i>
                                                            </div>
                                                            <div v-else class="gps-logo pointer" :id="'DisableOnClick' + i + field_index" @click="getMultiPartLocation(field_index ,i)">
                                                                <i class="icon-crosshairs-gps color-blue" ></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.error && td.location_details.location_vmodel == ''">The Location field is required</span>
                                                </div>
                                                <div v-if="td.statement">
                                                    <textarea v-model="td.reason" v-validate="td.required ? 'required' : ''" class="text-reason" 
                                                    :name="`reason${i}${field_index}`" style="resize: none;" data-vv-as="Reason" placeholder="Enter a reason"></textarea>
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has(`reason${i}${field_index}`)">{{errors.first(`reason${i}${field_index}`)}}</span>
                                                </div>
                                                <!-- Multi Part Field Attachments -->
                                                <div class="mt-3" v-if="td.add_attachments">
                                                    <span class="fw-500 fs-15px">Attachments</span>
                                                    <span style="position:absolute;margin-top:-10px;left:auto; margin-left: -2px;">
                                                        <el-tooltip class="item pull-right" effect="dark" content="Supports .doc, .docx, .pdf, .ppt, .pptx, .txt, .xls,
                                                            .xlsx,.bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv
                                                            Size limit- 25.00 MB (Max. 10 files)" placement="top">
                                                            <i class="ri-2x ri-information-line text-black fs-16"></i>
                                                        </el-tooltip>
                                                    </span>
                                                    <div class="row mt-4 justify-content-first">
                                                        <div class="col-lg-12 col-md-12 col-sm-12 pr-0 p-med-12">
                                                            <div class="mt-4" @drop="dropAttachmentMPFieldAttachment($event, field_index, i)" @dragover="dragOverAttachment($event)">
                                                                <div class="img-upload pl-4 pr-sm-15 pt-3 pb-3 bg-white">
                                                                    <img width="30" src="/static/images/draganddrop.svg" class="" alt="Capture Image"/>
                                                                    <span class=" pl-4 hide-on-mob">Drag and Drop Files Here </span>
                                                                    <span class="px-12 hide-on-mob" style="font-weight:600 !important;">OR</span>
                                                                        <file-upload id="multiple" input-id="file1" v-if="td.attachments.length < 5"
                                                                            class="choose-file btn btn-new-primary"
                                                                            type="file"
                                                                            @input-file="uploadMPFieldAttachment($event, field_index, i)" 
                                                                            accept=".pdf,.doc,.docx,.csv,.ods,.zip,.xls,image/*" ref="upload"
                                                                            webkitdirectory mozdirectory
                                                                            style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                                                            <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                                                            Click to Upload
                                                                        </file-upload>
                                                                        <label class="choose-file ml-2 btn-upload-disabled cursor-notallowed" v-else>
                                                                            Browse Files
                                                                        </label>
                                                                    <!-- <span class="pr-4 pl-4" style="font-weight:600 !important;">OR</span>
                                                                    <span class="pr-4 pointer">
                                                                        <img width="30" @click="openCaptureImage" src="/static/images/camera-3-line.svg" alt="Capture Image" v-if="attachments.length < 10"/>
                                                                        <img width="30" src="/static/images/camera-3-line.svg" class="cursor-notallowed" style="opacity:0.5 !important" alt="Capture Image" v-else/>
                                                                    </span>
                                                                    <span class="pr-4 pl-4 fw-600">OR</span> -->
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;border: solid 0px #2071d4;background-color: #f1f3f5; height: 80px;">
                                                                    <span class="fs-14 position-absolute" style="left: 15px; top: 8px;">Paste Image Here</span>
                                                                    <input type="text"
                                                                        @paste="handlePasteMultiPart($event, field_index, i)"
                                                                        readonly :id="'MultiPart'+field_index+''+i" :name="'MultiPart'+field_index+''+i"
                                                                        placeholder="'' Click here and press Ctrl + V to Paste ''"
                                                                        @input="handleInput" class="paste-input"
                                                                        style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;background-color: #f1f3f5;"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12" v-if="td.hasOwnProperty('attachments') && td.attachments.length > 0">
                                                            <div class="row my-5 text-center" style="overflow: auto;">
                                                                <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment, attachment_index) in td.attachments" :key="attachment_index">
                                                                    <div class="d-flex align-items-center mt-2 file-bg">
                                                                        <div class="d-flex align-items-center" style="width:90%">
                                                                            <div>
                                                                                <img src="/static/images/storage.svg" width="20" @click="previewImage(attachment)">
                                                                            </div>
                                                                            <div class="col">
                                                                                <div class="d-flex justify-content-between">
                                                                                    <el-tooltip :content="attachment.name" placement="top">
                                                                                        <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                            {{attachment.name}}
                                                                                        </div>
                                                                                    </el-tooltip>
                                                                                </div>
                                                                                <div v-if="attachment.uploading || attachment.url == undefined">
                                                                                    <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                                </div>
                                                                                <!-- <div class="d-flex justify-content-between">
                                                                                    <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                                    <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                                    <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                                </div> -->
                                                                            </div>
                                                                        </div>
                                                                        <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteMPFieldAttachment(field_index, i, attachment_index)">
                                                                            <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                            <img src="/static/images/delete-bin-4-line.svg" width="20" alt="" v-if="attachment.url">
                                                                            <!-- <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url"></i> -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div v-else class="col-lg-8 col-md-6 col-sm-12 pl-0 pl-med-12">
                                                            <div class="browse-box dotted-grey w-100 text-center">
                                                                <div class="no-att-msg"> 
                                                                    <span class="fs-20 fw-500">No Attachments Added</span>
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger mt-0" v-if="td.attachment_error">Attachments for this field is required</span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="general-section pt-2 pb-6 mt-4" v-if="(is_approvers_mandatory && field_index == 0) || (!is_approvers_mandatory)">
                                    <div class="attachment-bg attachment-bg-new">
                                        <div class="mt-4">
                                            <div class="img-upload pl-4 pr-sm-15 pt-3 pb-3 bg-white" @drop="dropAttachment($event, field_index)" @dragover="dragOverAttachment($event)">
                                                <img width="30" src="/static/images/draganddrop.svg" class="" alt="Capture Image"/>
                                                <span class=" pl-4 hide-on-mob">Drag and Drop Files Here</span>
                                                <span class="px-12 hide-on-mob" style="font-weight:600 !important;">OR</span>
                                                <file-upload id="multiple" input-id="file2"  v-if="field.attach_files.length < 10"
                                                    class="choose-file btn btn-new-primary"
                                                    :multiple="true"
                                                    :size="size || 0"
                                                    :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                                    :headers="headers"
                                                    :add-index="addIndex"
                                                    accept=".pdf,.doc,.docx,.csv,.ods,.zip,.xls,image/*"
                                                    @input-file="uploadAttachmentByPart($event, field_index)" ref="upload"
                                                    webkitdirectory mozdirectory
                                                    style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                                    <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                                    Click to Upload
                                                </file-upload>
                                                <!-- <label class="choose-file ml-2" v-if="field.attach_files.length < 10">
                                                    <input id="multiple" type="file" @change="uploadAttachmentByPart($event, field_index)" accept=".pdf,.doc,.docx,.csv,.ods,.zip,.xls,image/*">
                                                    
                                                </label> -->
                                                <!-- <label class="choose-file ml-2 cursor-notallowed btn-upload-disabled" v-else>
                                                    Browse Files
                                                </label>
                                                <span class="pr-4 pl-4" style="font-weight:600 !important;">OR</span>
                                                <span class="pr-4 pointer">
                                                    <img width="30" @click="openCaptureImageMulti(field_index)" src="/static/images/camera-3-line.svg" alt="Capture Image" v-if="field.attach_files.length < 10"/>
                                                    <img width="30" class="cursor-notallowed" style="opacity:.5 !important" src="/static/images/camera-3-line.svg" alt="Capture Image"  v-else/>
                                                </span>
                                                <span class="ml-4 text-center fw-600">OR</span> -->
                                            </div>
                                        </div>
                                        <div class="ml-4 mr-4">
                                            <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;border: solid 0px #2071d4;background-color: #f1f3f5; height: 80px;">
                                                <span class="fs-14 position-absolute" style="left: 15px; top: 8px;">Paste Image Here</span>
                                                <input type="text"
                                                    @paste="handlePasteByPart($event, field_index)"
                                                    readonly :id="'ByPart'+field_index" :name="'ByPart'+field_index"
                                                    placeholder="'' Click here and press Ctrl + V to Paste ''"
                                                    @input="handleInput" class="paste-input"
                                                    style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;background-color: #f1f3f5;"
                                                />
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap align-items-center mt-4">
                                            <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in field.attach_files" :key="index">
                                                <div class="d-flex align-items-center mt-6 file-bg">
                                                    <div class="d-flex align-items-center" style="width:90%">
                                                        <div>
                                                            <img src="/static/images/storage.svg" width="20" @click="previewImage(attachment)" >
                                                        </div>
                                                        <div class="col">
                                                            <div class="d-flex justify-content-between">
                                                                <el-tooltip :content="attachment.name" placement="top">
                                                                    <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                        {{attachment.name}}
                                                                    </div>
                                                                </el-tooltip>
                                                            </div>
                                                            <div v-if="attachment.uploading || attachment.url == undefined">
                                                                <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pointer ml-3" style="width:10%" @click="deleteAttachmentByPart(attachment,field_index)">
                                                        <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                        <img src="/static/images/delete-bin-4-line.svg" width="20" alt="" v-if="attachment.url && attachment.uploading == false">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <modal
                                            transition="nice-modal-fade"
                                            class="new-modal-default emergency-contact-list"
                                            :name="`capture-image${field_index}`"
                                            v-if="show_capture_image_multi"
                                            :delay="100"
                                            height="auto"
                                            :width="400"
                                            :adaptive="true" :scrollable="true"
                                        >
                                            <div class="v-modal-content" style="border-radius: 15px;background-color: #ebf3ff !important;">
                                                <div class="v-modal-body">
                                                    <div class="v-modal-layout d-flex justify-content-center">
                                                        <div id="app" class="web-camera-container mt-10">
                                                            <div v-show="isCameraOpen && isLoading" >
                                                                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                                            </div>
                                                            <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                                <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                                <video v-show="!isPhotoTaken" :ref="`camera_capture${field_index}`" :width="250" :height="250" autoplay></video>
                                                                <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="250" :height="250"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                                                    <a class="btn btn-danger-new text-white" style="text-transform: uppercase !important;" @click="hideViewMultiPart(field_index)">Cancel</a>
                                                    <button :disabled="!(isCameraOpen && !isLoading)" v-if="isCameraOpen && !isPhotoTaken" @click="takePhotoMultiPart(field_index)" type="button" class="btn btn-green ml-4" style="box-shadow: none;">
                                                        Capture
                                                    </button>
                                                    <button :disabled="!(isCameraOpen && !isLoading)" v-if="isPhotoTaken && isCameraOpen" @click="downloadImageByPart(field_index)" type="button" class="btn btn-green ml-4" style="box-shadow: none;">
                                                        Upload
                                                    </button>
                                                </div>
                                            </div>
                                        </modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row px-4" v-if="template_details.length > 0 && template_type == 'default'">
                            <div class="col-lg-12 col-md-12 col-sm-12" v-for="(td, i) in template_details" :key='i'>
                                <div class="d-flex flex-column justify-content-start" >
                                    <div class="fw-500 pt-2 pb-2 fs-14 text-black d-inline-block w-100 overflowing-text" :title="td.name">{{td.name.split('').length > 1 ?  td.name[0].toUpperCase() +''+ td.name.slice(1,) : td.name[0].toUpperCase()}}<span class="text-danger" v-if="td.required == true"> *</span></div>
                                    <div>
                                        <!-- Short Answer -->
                                        <input v-if="td.type == 'short_answer'"
                                        class=" inputFieldNew"
                                        style="padding-right: 30px !important;"
                                        type="text"
                                        v-model="td.answer"
                                        maxlength="100"
                                        placeholder="Enter Short Answer"
                                        :name="'short_answer'+ i"
                                        v-validate="td.required ? 'required' : ''"
                                        data-vv-as="Short Answer"
                                        />
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('short_answer'+ i)">{{errors.first('short_answer'+ i)}}</span>
                                        <!-- API Call Dropdown -->
                                        <div v-if="ticketType.name == 'Digicollect Product Template'">
                                            <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                v-model="td.answer" style="max-width:250px !important"
                                                class="diginew-multiselect down-arrow  mt-3"
                                                :loading="apicall_loading"
                                                :options="scm_products_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :name="'apidrop_down'+ i"
                                                track-by="_id"
                                                @close="insertProductTag(td.answer)"
                                                :show-labels="false"
                                                @search-change="searchTemplateApiDD"
                                                @open="getTemplateApiDD"
                                                :multiple="false"
                                                :options-limit="3000"
                                                :max-height="200"
                                                v-validate="td.required ? 'required' : ''"
                                                :clear-on-select="false"
                                                label="name"
                                                :internal-search="true"
                                                :show-no-results="true"
                                                :hide-selected="false"
                                                >
                                                    <template slot="placeholder">
                                                        <span class="diginewhelp-multiselect">Select Product</span>
                                                    </template>
                                                    <template slot="afterList">
                                                        <div v-observe-visibility="reachedEndOfApiDD" />
                                                    </template>
                                                    <template slot="noResult">
                                                        <div v-if="scm_products_options.length">
                                                            <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                            </div>
                                                        </div>
                                                        <div v-else class="text-secondary text-center fw-500">No Results Found</div>
                                                    </template>
                                            </multiselect>
                                        </div>
                                        <div v-else>
                                            <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                v-model="td.answer"
                                                style="max-width:250px !important"
                                                class="diginew-multiselect down-arrow mt-3"
                                                :loading="apicall_loading"
                                                :options="scm_products_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :name="'apidrop_down'+ i"
                                                :show-labels="false"
                                                @search-change="searchApiDD"
                                                @open="getApiDD"
                                                @close="insertProductTag(td.answer)"
                                                :multiple="false"
                                                :options-limit="3000"
                                                :max-height="200"
                                                v-validate="td.required ? 'required' : ''"
                                                :clear-on-select="false"
                                                label="name"
                                                :internal-search="true"
                                                :show-no-results="true"
                                                :hide-selected="false"
                                                >
                                                    <template slot="placeholder">
                                                        <span class="diginewhelp-multiselect">Select Product</span>
                                                    </template>
                                                    <template slot="afterList">
                                                        <div v-observe-visibility="reachedEndOfApiDD" />
                                                    </template>
                                                    <template slot="noResult">
                                                        <div v-if="scm_products_options.length">
                                                            <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                                <div></div>
                                                            </div>
                                                        </div>
                                                        <div v-else class="text-secondary text-center fw-500">No Results Found</div>
                                                    </template>
                                            </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('apidrop_down'+ i)">The Dropdown Field Is Required</span>
                                        <!-- Tags -->
                                        <div v-if="td.type == 'tag'">
                                            <vue-tags-input :name="'tags'+ i"
                                            data-vv-as="Tags" v-model="td.entered_tag" v-validate="td.required && td.answer.length == 0 ? 'required' : ''" class="multi_part-sec  inputFieldNew-tags create-edit-ticket-tags rel-x2 mt-3" :tags="td.answer" @tags-changed="tagsChangeData($event, i, 'by-field')" maxlength="40" :placeholder="ticketType.name == 'Digicollect Product Template' || ticketType.name == 'Product Bug Template' ? 'Add Custom Tags' : 'Enter Tags Here'" id='to_email' :delete-on-backspace="false" />
                                        </div>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('tags'+ i)">{{errors.first('tags'+ i)}}</span>
                                        <!-- Radiobutton -->
                                        <el-radio-group v-if="td.type == 'radio_button'" class="mt-5 mob-issue-fix w-100" v-model="td.answer" v-validate="td.required ? 'required' : ''" :name="'radio_button'+ i" data-vv-as="Radio Button">
                                            <div class="row">
                                                <el-radio class="col-xl-2 col-lg-2 col-md-3 col-sm-6 text-capitalize fs-14 d-flex word-wrap" :label="radio_options" v-for="(radio_options, ri) in td.possible_values" :key="ri">
                                                    {{radio_options}}
                                                </el-radio>
                                            </div>
                                        </el-radio-group>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('radio_button'+ i)">{{errors.first('radio_button'+ i)}}</span>
                                        <!-- Checkbox -->
                                        <el-checkbox-group v-if="td.type == 'check_box'" class="refund-checkbox mt-4  w-100" v-validate="td.required ? 'required' : ''" :name="'check_box'+ i" data-vv-as="Check Box" v-model="td.answer">
                                            <div class="row">
                                                <!-- <div> -->
                                                    <el-checkbox class="text-capitalize col-xl-2 col-lg-2 col-md-3 col-sm-6 d-flex word-wrap" :label="check_options" v-for="(check_options, ci) in td.possible_values" :key="ci">
                                                        {{check_options}}
                                                    </el-checkbox>
                                                <!-- </div> -->
                                            </div>
                                        </el-checkbox-group>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('check_box'+ i)">{{errors.first('check_box'+ i)}}</span>
                                        <!-- Date -->
                                        <date-picker v-if="td.type == 'date'"
                                        class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor" placeholder="MM/DD/YYYY"
                                            v-validate="td.required ? 'required' : ''"
                                            :name="'date'+ i" onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                            data-vv-as="Date" :editable="true"
                                            value-type="format"
                                            format="MM/DD/YYYY" type="date" lang="en" v-model="td.answer"
                                            style="border:none !important">
                                        </date-picker>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date'+ i)">{{errors.first('date'+ i)}}</span>
                                        <!-- Time -->
                                        <date-picker v-if="td.type == 'time'"
                                            v-model="td.answer"
                                            format="hh:mm A"
                                            :name="'time'+ i"
                                            data-vv-as="Time"
                                            class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon"
                                            type="time" onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                            placeholder="Enter the time"
                                            lang="en"
                                            value-type="format"
                                            :clearable="false"
                                            :editable="true"
                                            :minute-step="1"
                                            @confirm="HandleTimeEvent($event, i, 'time')"
                                            confirm
                                            confirm-text="APPLY"
                                            v-validate="td.required ? 'required' : ''"
                                        ></date-picker>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required && td.answer == ''" v-show="errors.has('time'+ i)">{{errors.first('time'+ i)}}</span>
                                        <!-- Date and time -->
                                        <div class="d-flex align-items-center" v-if="td.type == 'date_time'">
                                            <div class="row">
                                                <date-picker v-if="td.type == 'date_time'"
                                                    class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor col-lg-6 col-md-6 col-sm-12" placeholder="MM/DD/YYYY"
                                                    v-validate="td.required ? 'required' : ''"
                                                    :name="'date_time'+ i" onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                                    data-vv-as="Date" :editable="true"
                                                    value-type="format"
                                                    format="MM/DD/YYYY" type="date" lang="en" v-model="td.date"
                                                    style="border:none !important">
                                                </date-picker>
                                                <date-picker v-if="td.type == 'date_time'"
                                                    v-model="td.time"
                                                    format="hh:mm A"
                                                    :name="'date_time'+ i"
                                                    data-vv-as="Time"
                                                    class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon col-lg-6 col-md-6 col-sm-12"
                                                    type="time" onkeypress="return event.charCode >= 48 && event.charCode <= 58"
                                                    placeholder="Enter the time"
                                                    lang="en"
                                                    value-type="format"
                                                    :clearable="false"
                                                    :editable="true"
                                                    :minute-step="1"
                                                    @confirm="HandleTimeEvent($event, i, 'date_time')"
                                                    confirm
                                                    confirm-text="APPLY"
                                                    v-validate="td.required ? 'required' : ''"
                                                ></date-picker>
                                            </div>
                                        </div>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date_time'+ i)">The Date and Time field required</span>
                                        <!-- Long Answer -->
                                        <textarea placeholder="Enter Long Answer"  maxlength="500" v-validate="td.required ? 'required' : ''" :name="'long_answer'+ i" data-vv-as="Long Answer" v-if="td.type == 'long_answer'" v-model="td.answer" class="inputFieldNew mt-3"></textarea>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('long_answer'+ i)">{{errors.first('long_answer'+ i)}}</span>
                                        <!-- Dropdown -->
                                        <multiselect
                                            v-if="td.type == 'drop_down' && td.is_api_call_required == false"
                                            v-validate="td.required ? 'required' : ''"
                                            class="diginew-multiselect down-arrow mt-3"
                                            :name="'drop_down'+ i" style="width: 250px !important"
                                            data-vv-as="Drop Down"
                                            v-model="td.answer"
                                            :options="td.possible_values"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :show-labels="false"
                                        >
                                            <template slot="placeholder">
                                                <span class="diginewhelp-multiselect">Select Dropdown</span>
                                            </template>
                                        </multiselect>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('drop_down'+ i)">{{errors.first('drop_down'+ i)}}</span>
                                        <div v-if="td.type == 'location'">
                                            <div class="digi-table-loader d-flex justify-content-center" v-if="location_loader" id="spinner" style="margin: 0 auto;position:absolute;left:40%">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                            <div class="form-group contactGroup pt-0 mb-0">
                                                <div class="d-flex align-items-center">
                                                    <div class="form-group gMap" style="position:relative;width:100%;padding-top:1.3rem !important">
                                                        <!-- <input class="inputFieldNew overflowing-text mt-0 " style="padding-right: 30px !important;" :name="'location' + i" type="text"  v-model="td.location_details.location_vmodel" placeholder="Enter Location" /> -->
                                                        <!-- id="autocompleteInput"  @place_changed="locationAddress"  name="get_location" :value="location.full_address" -->

                                                        <gmap-autocomplete class="" id="map2"  name="get_location"  placeholder="Search Location " @place_changed="locationAddress($event, i)" 
                                                        :value="td.location_details.location_vmodel" ref=""
                                                                    style="padding: 8px 88px 8px 18px !important; height: 40px;background: #f1f1f1; width:100%; border:none !important;"></gmap-autocomplete>
                                                        <div class="d-flex">
                                                            <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                        </div>
                                                    </div>
                                                    <div class="gps-logo pointer" :id="'DisableOnClick' + i" @click="getLocation(i)">
                                                        <i class="icon-crosshairs-gps color-blue" ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                     <span class="invalid-feedback-form text-danger mt-0" v-if="td.error && td.location_details.location_vmodel == ''">The Location field is required</span>
                                        <div v-if="td.statement">
                                            <textarea v-model="td.reason" v-validate="td.required ? 'required' : ''" class="text-reason" :name="`reason${i}`" style="resize: none;" data-vv-as="Reason" placeholder="Enter a reason"></textarea>
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has(`reason${i}`)">{{errors.first(`reason${i}`)}}</span>
                                        </div>
                                        <!-- Default Field Attachments -->
                                        <div class="mt-3" v-if="td.add_attachments">
                                            <span class="fw-500 fs-15px">Attachments</span>
                                            <span style="position:absolute;margin-top:-10px;left:auto; margin-left: -2px;">
                                                <el-tooltip class="item pull-right" effect="dark" content="Supports .doc, .docx, .pdf, .ppt, .pptx, .txt, .xls,
                                                    .xlsx,.bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv
                                                    Size limit- 25.00 MB (Max. 10 files)" placement="top">
                                                    <i class="ri-2x ri-information-line text-black fs-16"></i>
                                                </el-tooltip>
                                            </span>
                                            <div class="row mt-4 justify-content-frsm">
                                                <div class="col-lg-12 col-md-12 col-sm-12 pr-0 p-med-12">
                                                    <div class="mt-4" @drop="dropAttachmentDefaultFieldAttachment($event, i)" @dragover="dragOverAttachment($event)">
                                                        <div class="img-upload pl-4 pr-sm-15 pt-3 pb-3 bg-white">
                                                            <img width="30" src="/static/images/draganddrop.svg" class="" alt="Capture Image"/>
                                                            <span class=" pl-4 hide-on-mob">Drag and Drop Files Here</span>
                                                            <span class="px-12 hide-on-mob" style="font-weight:600 !important;">OR</span>
                                                                <file-upload id="multiple" input-id="file3" v-if="td.attachments.length < 5"
                                                                    class="choose-file btn btn-new-primary"
                                                                    accept=".pdf,.doc,.docx,.csv,.ods,.zip,.xls,image/*"
                                                                    @input-file="uploadDefaultFieldAttachment($event, i)" 
                                                                    webkitdirectory mozdirectory
                                                                    style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                                                    <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                                                    Click to Upload
                                                                </file-upload>
                                                                <label class="choose-file ml-2 btn-upload-disabled cursor-notallowed" v-else>
                                                                    Browse Files
                                                                </label>
                                                            <!-- <span class="pr-4 pl-4" style="font-weight:600 !important;">OR</span>
                                                            <span class="pr-4 pointer">
                                                                <img width="30" @click="openCaptureImage" src="/static/images/camera-3-line.svg" alt="Capture Image" v-if="attachments.length < 10"/>
                                                                <img width="30" src="/static/images/camera-3-line.svg" class="cursor-notallowed" style="opacity:0.5 !important" alt="Capture Image" v-else/>
                                                            </span>
                                                            <span class="pr-4 pl-4 fw-600">OR</span> -->
                                                        </div>
                                                    </div>
                                                    <div class="mr-4">
                                                        <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;border: solid 0px #2071d4;background-color: #f1f3f5; height: 80px;">
                                                            <span class="fs-14 position-absolute" style="left: 15px; top: 8px;">Paste Image Here</span>
                                                            <input type="text"
                                                                @paste="handlePasteDefaultField($event, i)"
                                                                readonly :id="'DefaultField'+i" :name="'DefaultField'+i"
                                                                placeholder="'' Click here and press Ctrl + V to Paste ''"
                                                                @input="handleInput" class="paste-input"
                                                                style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;background-color: #f1f3f5;"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 col-md-12 col-sm-12" v-if="td.hasOwnProperty('attachments') && td.attachments.length > 0">
                                                    <div class="row text-center" style="overflow: auto;">
                                                        <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment, attachment_index) in td.attachments" :key="attachment_index">
                                                            <div class="d-flex align-items-center mt-2 file-bg">
                                                                <div class="d-flex align-items-center" style="width:90%">
                                                                    <div>
                                                                        <img src="/static/images/storage.svg" width="20" @click="previewImage(attachment)">
                                                                    </div>
                                                                    <div class="col">
                                                                        <div class="d-flex justify-content-between">
                                                                            <el-tooltip :content="attachment.name" placement="top">
                                                                                <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                    {{attachment.name}}
                                                                                </div>
                                                                            </el-tooltip>
                                                                        </div>
                                                                        <div v-if="attachment.uploading || attachment.url == undefined">
                                                                            <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                        </div>
                                                                        <!-- <div class="d-flex justify-content-between">
                                                                            <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                            <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                            <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                        </div> -->
                                                                    </div>
                                                                </div>
                                                                <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteDefaultFieldAttachment(i, attachment_index)">
                                                                    <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                    <img src="/static/images/delete-bin-4-line.svg" width="20" alt="" v-if="attachment.url">
                                                                    <!-- <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url"></i> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div v-else class="col-lg-8 col-md-6 col-sm-12 pl-0 pl-med-12">
                                                    <div class="browse-box text-center">
                                                        <div class="no-att-msg"> 
                                                            <span class="fs-20 fw-500">No Attachments Added</span>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>
                                            <span class="invalid-feedback-form text-danger mt-0" v-if="td.attachment_error">Attachments for this field is required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="general-section general-box pt-2 pb-6 mt-4 d-flex justify-content-center px-4" v-if="template_type == 'default'">   
                        <div class="attachment-bg attachment-bg-new">
                            <div class="text-black ml-4 fw-600 fs-15 mt-2">Upload Files</div>
                            <div class="mt-4" @drop="dropDefaultAttachment($event)" @dragover="dragOverAttachment($event)">
                                <div class="img-upload pl-4 pr-sm-15 pt-3 pb-3 bg-white">
                                    <img width="30" src="/static/images/draganddrop.svg" class="" alt="Capture Image"/>
                                    <span class=" pl-4 hide-on-mob">Drag and Drop Files Here</span>
                                    <span class="px-12 hide-on-mob" style="font-weight:600 !important;">OR</span>
                                        <file-upload id="multiple" input-id="file4" v-if="attachments.length < 10"
                                            class="choose-file btn btn-new-primary"
                                            :multiple="true"
                                            :size="size || 0"
                                            :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                            :headers="headers"
                                            :add-index="addIndex"
                                            accept=".doc, .docx, .htm, .html, .pdf, .ppt, .pptx, .txt, .Xls, .xlsx, .bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .flv, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv, .mov.csv,.ods,.zip,"
                                            @input-file="uploadAttachmentsData($event)" ref="upload"
                                            webkitdirectory mozdirectory
                                            style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                            <i class="icon ri-upload-2-line text-white fs-15 pr-1"></i>
                                            Click to Upload
                                        </file-upload>
                                        <label class="choose-file ml-2 btn-upload-disabled cursor-notallowed" v-else>
                                            Browse Files
                                        </label>
                                    <!-- <span class="pr-4 pl-4" style="font-weight:600 !important;">OR</span>
                                    <span class="pr-4 pointer">
                                        <img width="30" @click="openCaptureImage" src="/static/images/camera-3-line.svg" alt="Capture Image" v-if="attachments.length < 10"/>
                                        <img width="30" src="/static/images/camera-3-line.svg" class="cursor-notallowed" style="opacity:0.5 !important" alt="Capture Image" v-else/>
                                    </span>
                                     <span class="pr-4 pl-4 fw-600">OR</span> -->
                                </div>
                            </div>
                            <div class="ml-4 mr-4">
                                <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;border: solid 0px #2071d4;background-color: #f1f3f5; height: 80px;">
                                    <span class="fs-14 position-absolute" style="left: 15px; top: 8px;">Paste Image Here</span>
                                    <input type="text"
                                        @paste="handlePasteDefaultAttachment"
                                        readonly :id="'DefaultAttachment'" :name="'DefaultAttachment'"
                                        placeholder="'' Click here and press Ctrl + V to Paste ''"
                                        @input="handleInput" class="paste-input"
                                        style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;background-color: #f1f3f5;"
                                    />
                                </div>
                            </div>
                            <div class="d-flex flex-wrap align-items-center mt-4">
                                <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in attachments" :key="index">
                                    <div class="d-flex align-items-center mt-6 file-bg">
                                        <div class="d-flex align-items-center" style="width:95%">
                                            <div>
                                                <img src="/static/images/storage.svg" width="20" @click="previewImage(attachment)">
                                            </div>
                                            <div class="col">
                                                <div class="d-flex justify-content-between">
                                                    <el-tooltip :content="attachment.name" placement="top">
                                                        <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                            {{attachment.name}}
                                                        </div>
                                                    </el-tooltip>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined">
                                                    <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                </div>
                                                <!-- <div class="d-flex justify-content-between">
                                                    <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                    <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                    <div class="fw-500" v-if="attachment.size">{{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}}</div>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="pointer ml-3" style="width:5%" @click="deleteAttachment(attachment,index)">
                                            <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                            <img src="/static/images/delete-bin-4-line.svg" width="20" alt="" v-if="attachment.url && attachment.uploading == false">
                                            <!-- <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <modal
                                transition="nice-modal-fade"
                                class="new-modal-default emergency-contact-list"
                                name="capture-image"
                                v-if="show_capture_image"
                                :delay="100"
                                height="auto"
                                :width="400"
                                :adaptive="true" :scrollable="true"
                            >
                                <div class="v-modal-content" style="border-radius: 15px;background-color: #ebf3ff !important;">
                                    <div class="v-modal-body">
                                        <div class="v-modal-layout d-flex justify-content-center">
                                            <div id="app" class="web-camera-container mt-10">
                                                <div v-show="isCameraOpen && isLoading" >
                                                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                                </div>
                                                <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                    <video v-show="!isPhotoTaken" ref="camera_capture" :width="250" :height="250" autoplay></video>
                                                    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="250" :height="250"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                                        <a class="btn btn-danger-new  text-white" style="text-transform: uppercase !important;" @click="hideView()">Cancel</a>
                                        <button :disabled="!(isCameraOpen && !isLoading)" v-if="isCameraOpen && !isPhotoTaken" @click="takePhoto" type="button" class="btn btn-green ml-4" style="box-shadow: none;">
                                            Capture
                                        </button>
                                        <button :disabled="!(isCameraOpen && !isLoading)" v-if="isPhotoTaken && isCameraOpen" @click="downloadImage" type="button" class="btn btn-green ml-4" style="box-shadow: none;">
                                            Upload
                                        </button>
                                    </div>
                                </div>
                            </modal>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-4" v-if="generalActive && (template_type == 'default' || template_type == 'multi_part')">
                        <div></div>
                        <div>
                            <button class="btn btn-danger-new  text-white mr-0" style="text-transform: capitalize !important;border-radius: 5px !important;" 
                                @click="cancel()" :disabled="isUploadingInProgress || load_template || save_loader">
                                Cancel
                            </button>
                            <button v-if="template_type == 'multi_part'" type="button" :disabled="isUploadingInProgress || load_template || save_loader" :class="{'btn-green': is_approvers_mandatory,
                                    'btn-secondary':!is_approvers_mandatory, 'text-align-left': save_loader, 'w-140' :is_approvers_mandatory && save_loader, 'w-130' :!is_approvers_mandatory && save_loader}" 
                                    class="btn  ml-3" style="box-shadow: none;border-radius: 5px !important" @click="validateNext()">
                                {{ is_approvers_mandatory ? 'Send for Review' : 'Skip and Next'}}
                                <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:50px" />
                            </button>
                            <button v-else :disabled="isUploadingInProgress || load_template || save_loader" class="btn btn-green ml-3" :class="save_loader ? 'w-90 text-align-left' : 'text-center'" style="box-shadow: none;border-radius: 5px !important" @click="validateNext()">
                                {{save_loader ? 'Saving' : 'Save'}}
                                <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <UploadingImage product_name="DigiHelp" :uploadData="uploadData" :template_details="template_details" :attachments="attachments" @show_capture_image_multi="showCaptureImageMulti" @show_capture_image="showCaptureImage" @attachmentForceUpdate="attachmentForceUpdate" :refsData="$refs"/> -->
        <!-- <Uploadingimage product_name="DigiHelp" :uploadData="uploadData" :template_details="template_details" :attachments="attachments" /> -->
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
        <file-viewer v-if="show_file_viewer" :fileType="doc_file_url_type" :fileUrl="file_url_for_view" :file_name_for_view='file_name_for_view' :file_type_for_view="file_type_for_view" @hideFileViewer="hideFileViewer"></file-viewer>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
var mime = require('mime-types')
import { HalfCircleSpinner } from "epic-spinners";
import {Locator} from '@digicollect_front_end/digi-fe-library'
import VueTagsInput from "@johmun/vue-tags-input";
import { VueEditor } from "vue2-editor";
import scm from '../mixins/scm.js';
import facility_mgmt from '../mixins/facility_mgmt';
import time_utils from '../mixins/time_utils';
import crm from '../mixins/crm.js';
import ticket from '../mixins/ticket.js';
import { SweetModal } from 'sweet-modal-vue';
import FileUpload from 'vue-upload-component';
import SoftwareBugTemplate from "./SoftwareBugTemplate";
import axios from 'axios';
import attachments_handler from "../mixins/attachments_handler.js";
// import attachments_handler from '@digicollect_front_end/digi-fe-library/src/components/mixins/attachments_handler.js';
// import UploadingAttachments from '@digicollect_front_end/digi-fe-library/src/components/mixins/attachments_handler.js'
import {EventBus} from "../eventBus/nav-bar-event.js";
import Preview from "../Preview.vue";
import FileViewer from '../FileViewer.vue'
import { debounce } from 'lodash';
import VueBus from 'vue-bus';
export default {
    // attachments_handler
    mixins:[scm,crm,ticket, facility_mgmt, time_utils, attachments_handler],
    components:{
        HalfCircleSpinner,
        VueTagsInput,
        VueEditor,
        SweetModal,
        FileUpload,
        VueBus,
        SoftwareBugTemplate,
        Preview,
        FileViewer,
        Locator

        // 'digi-uploadingimage': DigiCollectLibrary.Uploadingimage,
    },
    data(){
        return{
            toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction
                    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['clean']
                    // [ 'link','image','video']  p                                
            ],
            preview_file: '',
            preview_visible: false,
            // temp data
            template_name: '',
            templateNamelength: 30,

            template_data: [],
            entered_tag: '',
            load_template: false,
            tags_template: [],
            isVisible: false,
            template_search_key: '',
            ticketName: '',
            ticket_name_options: [],
            model_name: '',
            model_name_options: [],
            model_number: 0,
            radio_select: '',
            date_of_purchase: '',
            time_of_purchase: '',
            ticketTemplateListScrollable: false,
            template_details: [],

            camera_selection: [],
            selected_camera_device: '',
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoading: false,
            isCameraOpen: false,

            show_capture_image: false,
            show_capture_image_multi: false,
            ticket_details_description: '',
            refund_reason: [],
            time_of_purchase: '',
            success_msg:'',
            warning_msg:'',
            behalf:'myself',
            assignedTo:'person',
            subject:'',
            department:'',
            department_options:[],
            assignedCustomer:'',
            assign_options:[],
            ticketType:'',
            ticket_type_options:[],
            ticket_type_count: 0,
            subjectlength:100,
            descriptionlength:1000,
            ajaxCallinprogress:false,
            customer_options:[],
            customer:'',
            vendor_options:[],
            vendor:'',
            vendor_count:0,
            vendor_loading:false,
            vendor_scrollable:false,
            vendor_visible:false,
            branch_count:0,
            branch_loading:false,
            branch_scrollable:false,
            branch_visible:false,
            search_key:'',
            temp_vendor_options:[],
            customer_loading:false,
            customer_count:0,
            temp_customer_options:[],
            customer_scrollable:false,
            cutomer_visible:false,
            viewMore:false,
            authorized_person_id:'',
            authorized_person_name:'',
            authorized_department:'',
            authorized_branch:'',
            authorized_email:'',
            authorized_phone:'',
            ticket_template_type:'',
            temp_assign_options:[],
            assign_loading:false,
            assign_scrollable:false,
            assign_count:0,
            assign_visible:false,
            description:'',
            showDescription:false,
            is_parent_ticket:true,
            parent_ticket_id:'',
            ticket_type_loading:false,
            is_validated:false,
            auto_fill_data:{},
            autoFilled:false,
            max_due_date:'',
            max_due_time:'',
            api_date:'',
            temp_attachments:[],
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            total_file_size: 0,
            multiple: true,
            directory: true,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            uploadAuto: false,
            isOption: false,
            attachments:[],
            parentTicketDetails:'',
            nameOfTicket:'',
            priority:'',
            date_time_of_purchase:[],
            due_date:'',
            product_id:'',
            machine_hours:[],
            crm_customer_id:'',
            branch_options:[],
            branch_name:'',
            generalActive:true,
            productActive:false,
            jobtypeActive:false,
            tab_active1:true,
            tab_active2:false,
            job_ticket_template: '',
            temp_branch_options:[],
            branch_active: false,
            customer_address:'',
            job_type:'',
            jobTypes:[],
            check_ticket_template_type: '',
            sbr_active: false,
            is_service_ticket: false,
            branch_search: '',
            apicall_loading: false,
            scm_products_options: [],
            scm_products_count: 0,
            isUploadingInProgress:false,
            is_drop:false,
            is_input_data :false,
            temp_location: {
                address:"",
                city:"",
                country:"",
                full_address:"",
                location_vmodel:"",
                state:"",
                street1:"",
                township:"",
                zip_code:""
            },
            template_type: '',
            description_length: 0,

            // Approvers Data
            approvers_data: [],
            approvers_scrollable: false,
            approvers_loading: false,
            approvers_count: 0,
            temp_approvers_options: 0,
            approvers_options: [],
            is_approvers_mandatory: false,
            check_attachments: false,
            location_loader: false,
            save_loader: false,
            limit: 993,
            uploadData: [],
            show_hide_general_details: true,
            show_file_viewer: false,
            doc_file_url_type: '',
            file_url_for_view:'',
            file_name_for_view: "",
            file_type_for_view: '',
            priority_of_ticket: '',
        }
    },
    methods:{
        showCaptureImageMulti(e){
            this.show_capture_image_multi = e
        },
        showCaptureImage(e){
            this.show_capture_image = e
        },
        onTextChange() {
            const quill = this.$refs.editor.quill
            const len = quill.getLength()
            this.description_length = len-1
            if (len > this.limit) {
                quill.deleteText(this.limit, len);
            }
        },
        hidePreview(){
            this.preview_visible = false;
            EventBus.$emit('ZindexChangeEnd')
        },
        previewImage(file) {
            EventBus.$emit('ZindexChangeStart')
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            if(this.preview_file.name.endsWith('.doc') || this.preview_file.name.endsWith('.docx') || this.preview_file.name.endsWith('.pdf') 
                || this.preview_file.name.endsWith('.ppt') || this.preview_file.name.endsWith('.pptx') || this.preview_file.name.endsWith('.txt') 
                || this.preview_file.name.endsWith('.txt') || this.preview_file.name.endsWith('.xls') || this.preview_file.name.endsWith('.xlsx') 
                || this.preview_file.name.endsWith('.xlsx') || this.preview_file.name.endsWith('.bmp') || this.preview_file.name.endsWith('.jpeg') 
                || this.preview_file.name.endsWith('.png') || this.preview_file.name.endsWith('.svg') || this.preview_file.name.endsWith('.avi') 
                || this.preview_file.name.endsWith('.mp3') || this.preview_file.name.endsWith('.mpeg') || this.preview_file.name.endsWith('.mp4')
                || this.preview_file.name.endsWith('.jpg')
            ){
                if (/\.(docx|xlsx|pptx|doc|xls|ppt|pdf|svg|txt)$/i.test(file.name)) {
                    this.viewFile(this.preview_file)
                } else {
                    this.preview_visible = true;
                }
            } else {
                this.$toasted.global.error("File Format Not Supported")
            }
        },
        viewFile(file) {
            this.file_url_for_view = file.url || "";
            this.file_name_for_view = file.name;
            this.show_file_viewer = true;
            this.file_type_for_view = file.content_type
        },
        hideFileViewer() {
            this.show_file_viewer = false;
            EventBus.$emit('ZindexChangeEnd')
        },
        goTOBack(){
            this.$router.go(-1)
        },
        showHideGeneralDetails() {
            this.show_hide_general_details = !this.show_hide_general_details
        },
        HandleTimeEventMultiPart(event, part_index, indx, type){
            if(type == 'date_time'){
                if(event == ''){
                    this.template_details[part_index].parts_data[indx].time = '12:00 am'
                }
            } else if(type == 'time'){
                if(event == ''){
                    this.template_details[part_index].parts_data[indx].answer = '12:00 am'
                }
            }
            this.$forceUpdate()
        },
        HandleTimeEvent(event, indx, type){
            if(type == 'date_time'){
                if(event == ''){
                    this.template_details[indx].time = '12:00 am'
                }
            } else if(type == 'time'){
                if(event == ''){
                    this.template_details[indx].answer = '12:00 am'
                }
            }
            this.$forceUpdate()
        },
        ToggleParts(part){
            if(part.show){
                part.show = false
            } else {
                part.show = true
            }
            this.$forceUpdate();
        },
        removeApprovers(option){
            this.approvers_data.forEach((el,index)=>{
                if(el == option){
                    this.approvers_data.splice(index,1)
                }
            })
        },
        async reachedEndOfApprovers(reached){
            if(reached){
                if(this.approvers_scrollable == false){
                    this.approvers_loading = true
                    let params ={
                        skip:this.approvers_count,
                        limit:10,
                        search_key:''
                    }
                    let response = await this.getUserForTickets(params)
                    this.temp_approvers_options = response.response.assigned_user_details.length;
                    if (response.response.skip == this.approvers_count) {
                        if (this.temp_approvers_options > 0) {
                            let tempFiles = response.response.assigned_user_details;
                            tempFiles.forEach(el => {
                                this.approvers_options.push(el);
                            });
                            this.approvers_count += response.response.assigned_user_details.length;
                            this.approvers_loading = false
                        } else {
                            this.approvers_scrollable = true
                            this.approvers_loading = false
                        }
                    }
                }
            }
        },
        tagsChangeData(update_tag, index, mode){
            if(mode == 'by-field'){
                this.template_details[index].answer = update_tag
            } else if(mode == 'by-function'){
                this.template_details[index].answer=update_tag
                setTimeout(() => {
                    document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                    document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                    document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                }, 500);
            }
            this.$forceUpdate()
        },
        tagsChangeMultiData(update_tag, part_index, index, mode){
            if(mode == 'by-field'){
                this.template_details[part_index].parts_data[index].answer = update_tag
            } else if(mode == 'by-function'){
                this.template_details[part_index].parts_data[index].answer = update_tag
                setTimeout(() => {
                    document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                    document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                    document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                }, 500);
            }
            this.$forceUpdate()
        },
        insertProductTag(answer){
            this.template_details.forEach((el, el_index) => {
                if(el.type == "tag" && answer != ''){
                    let temp_ans = [...new Set(el.answer.map(x => x))];
                    temp_ans.shift()
                    temp_ans.unshift({
                        text: answer.name,
                        tiClasses: [
                            "ti-valid"
                        ]
                    })
                    this.tagsChangeData(temp_ans, el_index, 'by-function')
                }
            })
            this.$forceUpdate()
        },
        insertMultiProductTag(answer){
            this.template_details.forEach((x, x_index) => {
                x.parts_data.forEach((el, el_index) => {
                    if(el.type == "tag" && answer != ''){
                        let temp_ans = [...new Set(el.answer.map(x => x))];
                        temp_ans.shift()
                        temp_ans.unshift({
                            text: answer.name,
                            tiClasses: [
                                "ti-valid"
                            ]
                        })
                        this.tagsChangeMultiData(temp_ans, x_index, el_index, 'by-function')
                    }
                })
            })
            this.$forceUpdate()
        },
        updateValue(newTags) {
            this.$emit('updateTags', newTags);
        },
        hideProductTemplate(template_name){
            if(template_name) {
                this.generalActive =false
                this.productActive =false
                this.jobtypeActive =true
                this.job_ticket_template = template_name;
            }else {
                this.generalActive =true
                this.productActive =false
                this.jobtypeActive =false;
                this.tab_active2 = false;
                this.job_ticket_template = template_name;
            }
        },
        assignLocationDetails(index){
            this.template_details[index].location_details = this.temp_location
        },
        assignMultiLocationDetails(part_index, field_index){
            this.template_details[part_index].parts_data[field_index].location_details = this.temp_location
        },
        setPlace(place,index) {
            let address = place.formatted_address.split(", ");
            this.temp_location['street1'] =
                address[address.length - 6] || "";
            this.temp_location['township'] =
                address[address.length - 4] || "";
            this.temp_location['city'] = address[address.length - 3] || "";
            let statezip = address[address.length - 2]
                ? address[address.length - 2].split(" ")
                : ["", ""];
            if (statezip.length == 1) {
                if (statezip[0].match(/^[0-9]+$/)) {
                this.temp_location['zip_code'] = statezip[0];
                } else {
                this.temp_location['state'] = statezip[0];
                }
            } else {
                this.temp_location['zip_code'] = statezip[0].match(/^[0-9]+$/)
                ? statezip[0]
                : statezip[1].match(/^[0-9]+$/)
                ? statezip[1]
                : "";
                this.temp_location['state'] = statezip[0].match(/^[a-zA-Z]+$/)
                ? statezip[0]
                : statezip[1].match(/^[a-zA-Z]+$/)
                ? statezip[1]
                : "";
            }
            if (address[address.length - 1].includes("-")) {
                let countrySelected = address[address.length - 1].split(" - ");
                countrySelected.forEach(x => {
                if (this.countries.includes(x)) {
                        this.temp_location['country'] = x;
                } else {
                        this.temp_location['country'] = "";
                }
                });
            } else {
                this.temp_location['country'] = address[address.length - 1];
            }
            this.temp_location['location_vmodel'] = place.formatted_address;
            this.temp_location['full_address'] = place.formatted_address;
            this.template_details[index].location_details = this.temp_location
            this.$forceUpdate();
        },
        locationAddress(place, index) {
            this.ajaxCallInProgress = true;
            let currentPlace = place;
            let address = place.formatted_address.split(', ')
            this.template_details[index].location_details.country = address[address.length-1] || ''
            this.template_details[index].location_details.township = address[address.length - 3] || "";
            this.template_details[index].location_details.building_no = currentPlace.vicinity
            this.template_details[index].location_details.city = address[address.length-3] || ''
            this.template_details[index].location_details.latitude = currentPlace.geometry.location.lat()
            this.template_details[index].location_details.longitude = currentPlace.geometry.location.lng()
            this.template_details[index].location_details.street = address[address.length - 4] || "";
            this.template_details[index].location_details.street1 = address[address.length - 4] || "";

            let statezip = address[address.length - 2] ?
                address[address.length - 2].split(" ") : ["", ""];
            this.template_details[index].location_details.state = statezip[0].match(/^[a-zA-Z]+$/) ?
                statezip[0] :
                statezip[1].match(/^[a-zA-Z]+$/) ?
                statezip[1] :
                "";
            this.template_details[index].location_details.zip_code = statezip[0].match(/^[0-9]+$/) ?
                statezip[0] :
                statezip[1].match(/^[0-9]+$/) ?
                statezip[1] :
                "";
            this.template_details[index].location_details.full_address = 
                (this.template_details[index].location_details.building_no ? this.template_details[index].location_details.building_no + ', ' : '') +
                (this.template_details[index].location_details.street ? this.template_details[index].location_details.street + ', ' : '') +
                (this.template_details[index].location_details.township ? this.template_details[index].location_details.township + ', ' : '') +
                (this.template_details[index].location_details.city ? this.template_details[index].location_details.city + ', ' : '') +
                (this.template_details[index].location_details.state ? this.template_details[index].location_details.state + ', ' : '') +
                (this.template_details[index].location_details.zip_code ? this.template_details[index].location_details.zip_code + ', ' : '') +
                (this.template_details[index].location_details.country ? this.template_details[index].location_details.country : '')
            this.template_details[index].location_details.location_vmodel =this.template_details[index].location_details.full_address
            this.locationLatLong(this.template_details[index].location_details.latitude,this.template_details[index].location_details.longitude)
            setTimeout(() => {
                this.ajaxCallInProgress = false;
            }, 1000);
            this.$forceUpdate();
        },
        locationLatLong(latitude,longitude){
            axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY`)
            .then(results=>{
                var i = 0
                var street_name
                var street_number
                for(i=0; i < results.data.results.length; i++){
                    for(var j=0;j < results.data.results[i].address_components.length; j++){
                        for(var k=0; k < results.data.results[i].address_components[j].types.length; k++){
                            if(results.data.results[i].address_components[j].types[k] == "postal_code"){
                                this.location.zip_code = results.data.results[i].address_components[j].short_name;
                            }
                            if(results.data.results[i].address_components[j].types[k] == 'route'){
                                street_name = results.data.results[i].address_components[j].short_name;
                            }
                            if(results.data.results[i].address_components[j].types[k] == 'street_number'){
                                street_number = results.data.results[i].address_components[j].short_name;
                            }
                        }
                    }
                }
                // this.location.street = street_number + ',' + ' ' +street_name
                // this.address_street = street_name
                // this.address_city = this.location.city
                // this.zipcode = this.location.zip_code
                // this.address_state = this.location.township
                // this.country = this.location.country
                // this.address_township = this.location.state,
                // this.building_no = this.location.building_no.substr(0,19),
                // this.address.latitude =  latitude
                // this.address.longitude = longitude
            })
            this.$forceUpdate();
        },


        getLocation(index) {
            // this.addressIndex = index;
            if (navigator.geolocation) {
                this.location_loader = true
                // console.log("Geolocation is supported!");
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    this.assignLocationDetails(index),
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation!");
            }
            // document.getElementById('DisableOnClick' + index).style.pointerEvents = 'none';
        },
        getMultiPartLocation(part_index, field_index){
            if (navigator.geolocation) {
                this.location_loader = true
                // console.log("Geolocation is supported!");
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    this.assignMultiLocationDetails(part_index, field_index),
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation!");
            }
            // document.getElementById('DisableOnClick' + field_index + part_index).style.pointerEvents = 'none';
        },
        showLocation(position) {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
            let calllatlong = axios.create();
            delete calllatlong.defaults.headers.common['Authorization'];
            calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
            .then(response => {
                let address = response.data.results[0].formatted_address.split(", ");
                this.temp_location['street1'] =
                address[address.length - 6] || "";
                this.temp_location['township'] =
                address[address.length - 4] || "";
                this.temp_location['city'] = address[address.length - 3] || "";
                let statezip = address[address.length - 2]
                ? address[address.length - 2].split(" ")
                : ["", ""];
                this.temp_location['zip_code'] = statezip[0].match(/^[0-9]+$/)
                ? statezip[0]
                : statezip[1].match(/^[0-9]+$/)
                ? statezip[1]
                : "";
                this.temp_location['state'] = statezip[0].match(/^[a-zA-Z]+$/)
                ? statezip[0]
                : statezip[1].match(/^[a-zA-Z]+$/)
                ? statezip[1]
                : "";
                if (address[address.length - 1].includes("-")) {
                let countrySelected = address[address.length - 1].split(" - ");
                countrySelected.forEach(x => {
                        if (this.countries.includes(x)) {
                        this.temp_location['country'] = x;
                        } else {
                        this.temp_location['country'] = "";
                        }
                });
                } else {
                this.temp_location['country'] = address[address.length - 1];
                }
                this.temp_location['location_vmodel'] = response.data.results[0].formatted_address;
                this.temp_location['full_address'] = response.data.results[0].formatted_address;
                this.location_loader = false
                this.$forceUpdate();
            })
            .catch(e => {
                // this.errors.push(e)
            });
        },
        errorHandler(err) {
            if (err.code == 1) {
                alert("Please Allow Location Access");
            } else if (err.code == 2) {
                alert("Error: Position is unavailable!");
            }
        },
        deleteAttachment(attachment,index){
            this.attachments.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.attachments.splice(elindex,1)
                }
            })
        },
        deleteAttachmentByPart(attachment,part_index){
            this.template_details[part_index].attach_files.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.template_details[part_index].attach_files.splice(elindex,1)
                }
            })
        },
        deleteMPFieldAttachment(part_index, field_index, attachment_index){
            this.template_details[part_index].parts_data[field_index].attachments.splice(attachment_index, 1)
            this.$forceUpdate()
        },
        deleteDefaultFieldAttachment(index, attachment_index){
            this.template_details[index].attachments.splice(attachment_index, 1)
            this.$forceUpdate()
        },
        cancel(){
            this.$router.push({
                name: 'TicketsList',
            })
        },
        validateNext(){
            if(this.template_type == 'default'){
                let check_errors = []
                this.template_details.forEach((template, template_index) => {
                    if(template.type == 'location' && template.required == true && template.location_details.location_vmodel == ''){
                        template.error = true
                    } else {
                        template.error = false
                    }
                    if(template.add_attachments && template.hasOwnProperty('attachments')){
                        if(template.required == true && template.attachments.length == 0){
                            check_errors.push(true)
                            template.attachment_error = true
                        } else {
                            check_errors.push(false)
                            template.attachment_error = false
                        }
                    }
                })
                this.$validator.validateAll().then(result => {
                    if (result == true && this.attachments.length <= 10 && this.template_details.every(this.checkError) && check_errors.every(x => x == false)){
                        this.attachments.forEach(attachment => {
                            delete attachment['created_time']
                            delete attachment['error']
                            delete attachment['id'];
                            delete attachment['progress']
                            // delete attachment['size']
                            delete attachment['uploading']
                        })
                        localStorage.setItem("ticketDetails", JSON.stringify(this.create_json));
                        let created_data = JSON.parse(localStorage.getItem('ticketDetails'));
                        created_data.template_data.forEach((template, index) => {
                            if(template.type == 'date_time'){
                                template.answer = template.date + ' ' + template.time
                                delete template.date
                                delete template.time
                            }
                            if(template.type == 'tag'){
                                template.answer.forEach((ti, ti_index) => {
                                    delete ti['tiClasses']
                                    template.answer[ti_index] = ti.text
                                })
                                delete template.entered_tag
                            }
                            if(template.type == 'drop_down' && template.is_api_call_required == true){
                                template.product = template.answer['_id']
                                delete template.answer['category']
                                delete template.answer['description']
                                delete template.answer['item_code']
                                delete template.answer['sub_category']
                                delete template.answer['variant_id']
                                delete template.answer['_id']
                                delete template.answer['name']
                                template.answer = template.product
                                delete template.product
                            }
                            if(template.type == 'location'){
                                template.answer = template.location_details.location_vmodel
                                delete template.location_details
                                delete template.error
                            }
                            if(template.type == 'check_box' || template.type == 'radio_button' || template.type == 'drop_down'){
                                delete template['possible_values']
                                if(template.hasOwnProperty('statement')){
                                    delete template.statement
                                }
                            }
                            if(template.add_attachments && template.hasOwnProperty('attachments')){
                                template.attachments.forEach((e) => {
                                    delete e['created_time']
                                    delete e['error']
                                    delete e['progress']
                                    // delete e['size']
                                    delete e['uploading']
                                })
                            }
                            delete template['add_attachments']
                            delete template['attachment_error']
                            delete template['is_api_call_required']
                            delete template['required']
                            delete template['type']
                            delete template['error']
                        })
                        try{
                            this.addNewTicket(created_data)
                        } catch(error) {
                        }
                    }
                    else if(this.attachments.length > 10){
                        this.$toasted.global.error("10 Attachments are Allowed")
                    }else{
                        this.$toasted.global.error("Please Fill All The Required Fields")
                        EventBus.$emit("scrollToTop");
                    }
                })
            } else {
                let check_errors = []
                if (this.is_approvers_mandatory) {
                    this.template_details.forEach((template, template_index) => {
                        template.parts_data.forEach((x, i) => {
                            if(this.is_approvers_mandatory){
                                if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == '' && template_index == 0){
                                    check_errors.push(true)
                                    x.error = true
                                } else {
                                    check_errors.push(false)
                                    x.error = false
                                }
                            } else {
                                if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == ''){
                                    check_errors.push(true)
                                    x.error = true
                                } else {
                                    check_errors.push(false)
                                    x.error = false
                                }
                            }
                            if(x.add_attachments && x.hasOwnProperty('attachments')){
                                if(x.required == true && x.attachments.length == 0){
                                    check_errors.push(true)
                                    x.attachment_error = true
                                } else {
                                    check_errors.push(false)
                                    x.attachment_error = false
                                }
                            }
                        })
                    })
                } else {
                    this.template_details.forEach((template, template_index) => {
                        template.parts_data.forEach((x, i) => {
                            if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == ''){
                                check_errors.push(true)
                                x.error = true
                            } else {
                                check_errors.push(false)
                                x.error = false
                            }
                            if(x.add_attachments && x.hasOwnProperty('attachments')){
                                if(x.required == true && x.attachments.length == 0){
                                    check_errors.push(true)
                                    x.attachment_error = true
                                } else {
                                    check_errors.push(false)
                                    x.attachment_error = false
                                }
                            }
                        })
                    })
                }
                this.$validator.validateAll().then(result => {
                    if (result == true && this.attachments.length <= 10 && check_errors.every(x => x == false)){
                        this.attachments.forEach(attachment => {
                            delete attachment['created_time']
                            delete attachment['error']
                            delete attachment['id'];
                            delete attachment['progress']
                            // delete attachment['size']
                            delete attachment['uploading']
                        })
                        localStorage.setItem("ticketDetails", JSON.stringify(this.create_multi_json));
                        let created_data = JSON.parse(localStorage.getItem('ticketDetails'));
                        created_data.template_data.forEach((template, index) => {
                            delete template.show
                            delete template.statement
                            template.attach_files.forEach((y) => {
                                delete y['created_time']
                                delete y['error']
                                delete y['id'];
                                delete y['progress']
                                // delete y['size']
                                delete y['uploading']
                            })
                            template.parts_data.forEach((y, y_index) => {
                                if(y.type == 'date_time'){
                                    y.answer = y.date + ' ' + y.time
                                    delete y.date
                                    delete y.time
                                }
                                if(y.type == 'tag'){
                                    y.answer.forEach((ti, ti_index) => {
                                        delete ti['tiClasses']
                                        y.answer[ti_index] = ti.text
                                    })
                                    delete y.entered_tag
                                }
                                if(y.type == 'drop_down' && y.is_api_call_required == true){
                                    y.product = y.answer['_id']
                                    delete y.answer['category']
                                    delete y.answer['description']
                                    delete y.answer['item_code']
                                    delete y.answer['sub_category']
                                    delete y.answer['variant_id']
                                    delete y.answer['_id']
                                    delete y.answer['name']
                                    y.answer = y.product
                                    delete y.product
                                }
                                if(y.type == 'location'){
                                    y.answer = y.location_details.location_vmodel
                                    delete y.location_details
                                    delete y.error
                                }
                                if(y.type == 'check_box' || y.type == 'radio_button' || y.type == 'drop_down'){
                                    delete y['possible_values']
                                    if(y.hasOwnProperty('statement')){
                                        delete y.statement
                                    }
                                }
                                if(y.add_attachments && y.hasOwnProperty('attachments')){
                                    y.attachments.forEach((e) => {
                                        delete e['created_time']
                                        delete e['error']
                                        delete e['progress']
                                        // delete e['size']
                                        delete e['uploading']
                                    })
                                }
                                delete y['add_attachments']
                                delete y['attachment_error']
                                delete y['is_api_call_required']
                                delete y['required']
                                delete y['type']
                                delete y['error']
                            })
                        })
                        try{
                            this.addNewTicket(created_data)
                        } catch(error) {
                            console.log(error)
                        }
                    }
                    else if(this.attachments.length > 10){
                        this.$toasted.global.error("10 Attachments are Allowed")
                    }else{
                        this.$toasted.global.error("Please Fill All The Required Fields")
                        EventBus.$emit("scrollToTop");
                    }
                })
            }
        },
        checkError(i) {
            return i.error == false;
        },
        async addNewTicket(created_data) {
            try{
                this.save_loader = true
                let response = await this.addTicket(created_data)
                if (response.status_id == 1){
                    this.success_msg = response.response.success_message
                    EventBus.$emit('RecallNotification')
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.save_loader = false
                        EventBus.$emit('RecallNotification')
                        this.$router.push('/ticketdetails/?view_ticket=overall');
                    }, 3000);
                } else if(response.status_id == 0){
                    this.save_loader = false
                    this.warning_msg = response.response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch(err) {
                this.save_loader = false
                this.warning_msg = err
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async getAllAssignToDebouncer(search_key){
            try {
                this.assign_options = []
                this.assign_loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getUserForTickets(params)
                this.assign_options = res.response.assigned_user_details
                this.assign_count = this.temp_assign_options.length
                this.assign_loading = false
                this.assign_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfAssigned(reached){
            this.assign_visible = reached
            if (reached) {
                if (this.assign_scrollable == false) {
                    this.assign_loading = true
                    let params ={
                        skip:this.assign_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserForTickets(params)
                    this.temp_assign_options = response.response.assigned_user_details.length;
                    if (response.response.skip == this.assign_count) {
                        if (this.temp_assign_options > 0) {
                            let tempFiles = response.response.assigned_user_details;
                            tempFiles.forEach(el => {
                                this.assign_options.push(el);
                            });
                            this.assign_count += response.response.assigned_user_details.length;
                            this.assign_loading = false
                        } else {
                            this.assign_scrollable = true
                            this.assign_loading = false
                        }
                    }
                    this.assign_loading = false
                }
            }
        },
        assignedToChange(){
            this.assignedCustomer = ''
            this.$validator.reset();
        },
        async getTicketTemplate(){
            this.ticket_type_loading = true
            try {
                let params = {
                    limit: 10,
                    search_key: '',
                    skip: 0,
                    sort_key: 'name',
                    sort_value: 1
                }
                let response = await this.getDynamicTemplateList(params)
                this.ticket_type_options = response.response.dynamic_details
                this.ticket_type_loading = false
                this.ticketTemplateListScrollable = false
            } catch (error) {
            }
        },
        async reachedEndOfTicketTemplate(reached){
            this.isVisible = reached;
            if (reached) {
                if(this.ticketTemplateListScrollable == false){
                    this.ticket_type_loading = true
                    let response = await this.getDynamicTemplateList({
                        search_key: this.template_search_key,
                        skip: this.ticket_type_count,
                        limit: 10,
                        sort_key: 'name',
                        sort_value: 1
                    })
                    let temp_ticket_template_options = response.response.dynamic_details.length
                    if(response.response.skip == this.ticket_type_count){
                        if(temp_ticket_template_options > 0){
                            let tempfiles = response.response.dynamic_details
                            tempfiles.forEach(el => {
                                this.ticket_type_options.push(el)
                            });
                            this.ticket_type_options = this.ticket_type_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.ticket_type_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.ticket_type_count += response.response.dynamic_details.length
                            this.ticket_type_loading = false
                        } else {
                            this.ticketTemplateListScrollable = true
                            this.ticket_type_loading = false
                        }
                    }
                    this.ticket_type_loading = false
                }
            }
        },
        async getApiDD(){
            this.apicall_loading = true
            try{
                let params = {
                    limit: 10,
                    search_key: "",
                    skip: 0
                }
                let response = await this.getScmProductsDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async getTemplateApiDD(){
            this.apicall_loading = true
            try{
                let params = {
                    limit: 10,
                    search_key: "",
                    skip: 0
                }
                let response = await this.getProductTemplatesDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async searchApiDDDebouncer(search_key){
            this.apicall_loading = true
            // this.template_search_key = search_key || '';
            try{
                let params = {
                    limit: 10,
                    search_key: search_key,
                    skip: 0
                }
                let response = await this.getScmProductsDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async searchTemplateApiDDDebouncer(search_key){
            this.apicall_loading = true
            // this.template_search_key = search_key || '';
            try{
                let params = {
                    limit: 10,
                    search_key: search_key,
                    skip: 0
                }
                let response = await this.getProductTemplatesDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async searchTemplateDebouncer(search_key){
            this.ticket_type_loading = true
            this.template_search_key = search_key || '';
            try{
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: this.template_search_key,
                    sort_key: 'name',
                    sort_value: 1
                }
                let response = await this.getDynamicTemplateList(params)
                this.ticket_type_options = []
                this.ticket_type_options = response.response.dynamic_details
                this.ticket_type_count = response.response.dynamic_details.length
                this.ticket_type_loading = false
            } catch (error) {
            }
        },
        getTemplateSpace(){
            if(this.template_type == 'multi_part'){
                this.template_details.forEach((x,index) => {
                    if(this.is_approvers_mandatory){
                        if(index == 0){
                            x.show = true
                            x.attach_files = []
                            x.is_send_for_review = this.is_approvers_mandatory
                            x.part_name = x.name
                            x.parts_data = JSON.parse(JSON.stringify(x.fields))
                            x.parts_data.forEach((data, data_index) => {
                                if(data.type == 'check_box' || data.type == 'radio_button') {
                                    data.answer = []
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'tag'){
                                    data.entered_tag = ''
                                    data.answer = []
                                    data.error = false
                                }
                                else if(data.type == 'dropdown' && data.is_api_call_required == true){
                                    data.answer = ''
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'drop_down' && data.is_api_call_required == false){
                                    data.answer = ''
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'date_time'){
                                    data.date = ''
                                    data.time = ''
                                    data.error = false
                                }
                                else if(data.type == 'location'){
                                    data.answer = ''
                                    data.location_details = {
                                        address:"",
                                        city:"",
                                        country:"",
                                        full_address:"",
                                        location_vmodel:"",
                                        state:"",
                                        street1:"",
                                        township:"",
                                        zip_code:""
                                    }
                                    data.error = false
                                }
                                else {
                                    data.answer = ''
                                    data.error = false
                                }
                                if(data.hasOwnProperty('add_attachments') && data.add_attachments){
                                    data.attachments = []
                                    data.attachment_error = false
                                }
                            })
                        } else {
                            x.part_name = x.name
                            x.parts_data = []
                        }
                    } else {
                        x.show = true
                        x.attach_files = []
                        x.is_send_for_review = this.is_approvers_mandatory
                        x.part_name = x.name
                        x.parts_data = JSON.parse(JSON.stringify(x.fields))
                        x.parts_data.forEach((data, data_index) => {
                            if(data.type == 'check_box' || data.type == 'radio_button') {
                                data.answer = []
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'tag'){
                                data.entered_tag = ''
                                data.answer = []
                                data.error = false
                            }
                            else if(data.type == 'dropdown' && data.is_api_call_required == true){
                                data.answer = ''
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'drop_down' && data.is_api_call_required == false){
                                data.answer = ''
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'date_time'){
                                data.date = ''
                                data.time = ''
                                data.error = false
                            }
                            else if(data.type == 'location'){
                                data.answer = ''
                                data.location_details = {
                                    address:"",
                                    city:"",
                                    country:"",
                                    full_address:"",
                                    location_vmodel:"",
                                    state:"",
                                    street1:"",
                                    township:"",
                                    zip_code:""
                                }
                                data.error = false
                            }
                            else {
                                data.answer = ''
                                data.error = false
                            }
                            if(data.hasOwnProperty('add_attachments') && data.add_attachments){
                                data.attachments = []
                                data.attachment_error = false
                            }
                        })
                    }
                    delete x.fields
                    delete x.name
                })
            } else {
                this.template_details.forEach((data,index) => {
                    if(data.type == 'check_box' || data.type == 'radio_button') {
                        this.template_details[index].answer = []
                        this.template_details[index].error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'tag'){
                        this.template_details[index].entered_tag = ''
                        this.template_details[index].answer = []
                        this.template_details[index].error = false
                    }
                    else if(data.type == 'dropdown' && data.is_api_call_required == true){
                        this.template_details[index].answer = ''
                        this.template_details[index].error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'drop_down' && data.is_api_call_required == false){
                        data.answer = ''
                        data.error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'date_time'){
                        this.template_details[index].date = ''
                        this.template_details[index].time = ''
                        this.template_details[index].error = false
                    }
                    else if(data.type == 'location'){
                        this.template_details[index].answer = ''
                        this.template_details[index].location_details = {
                            address:"",
                            city:"",
                            country:"",
                            full_address:"",
                            location_vmodel:"",
                            state:"",
                            street1:"",
                            township:"",
                            zip_code:""
                        }
                        this.template_details[index].error = false
                    }
                    else {
                        this.template_details[index].answer = ''
                        this.template_details[index].error = false
                    }
                    if(data.hasOwnProperty('add_attachments') && data.add_attachments){
                        data.attachments = []
                        data.attachment_error = false
                    }
                })
            }
        },
        async selectedTemplate(data){
            this.load_template = true
            this.save_loader = false
            this.approvers_data = []
            this.is_approvers_mandatory = false
            this.approvers_options = []
            try{
                let params = {
                    dynamic_template_id: data._id
                }
                let response = await this.getDynamicTemplate(params)
                this.template_type = response.response.template_type
                if(this.template_type == 'multi_part'){
                    this.approvers_options = response.response.approve_data
                    if(this.approvers_options.length > 0){
                        this.is_approvers_mandatory = true
                    } else {
                        this.is_approvers_mandatory = false
                    }
                    this.template_details = response.response.multi_parts_data
                    this.assignedTo = 'unassigned'
                } else {
                    this.is_approvers_mandatory = false
                    this.template_details = response.response.fields
                }
                this.getTemplateSpace()
                this.load_template = false
            } catch (error) {
                this.load_template = false
            }
        },
        checkTicketType(){
            if(this.ticketType == null) {
                this.template_details = []
            }
        },
        async getParentTicketData() {
            let param = {
                ticket_id: this.$route.params.id,
            }
            let res = await this.getDueDate(param);
            if(this.$route.params.id) {
                this.is_service_ticket = true
                this.is_parent_ticket = false;
            }
            this.customer = {
                label: res.response.on_behalf_of.details.company_name.name
            }
            this.branch_name = {
                name: res.response.on_behalf_of.details.branch.name,
                _id: res.response.on_behalf_of.details.branch.id
            }
            this.authorized_person_name = res.response.on_behalf_of.details.company_name.name
            this.authorized_department = res.response.on_behalf_of.details.department[0]
            this.authorized_branch = res.response.on_behalf_of.details.branch.name
            this.authorized_email = res.response.on_behalf_of.details.email
            this.authorized_phone = res.response.on_behalf_of.details.phone_number
            this.authorized_person_id = res.response.on_behalf_of.details.company_name.id
            this.customer_address = res.response.customer_address
        },
        handleInput() {
          // Reset the image when the user types or deletes content
          // this.imageUrl = '';
        },
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings
        },
        showDept(){
            return this.$store.state.store.showDepartment.display_department_section_in_base_template
        },
        onBehalf(){
            if(this.getGeneralSettings && this.getGeneralSettings.create_ticket_on_behalf_of){
                return this.getGeneralSettings.create_ticket_on_behalf_of.create_ticket_on_behalf_of
            }else{
                return ''
            }
        },
        showService(){
            return this.$store.state.store.showServiceTab.service_ticket_required
        },
        create_json(){
            return{
                assignment_details: {
                    id: this.assignedTo == 'unassigned' ? '' : this.assignedCustomer.id || '',
                    is_assigned: this.assignedTo == 'unassigned' ? false : true,
                    to: this.assignedTo
                },
                eisenhower_matrix:{
                    "imp_not_urgent": this.priority_of_ticket == 'imp_not_urgent' ? true : false,
                    "imp_urgent":  this.priority_of_ticket == 'imp_urgent' ? true : false,
                    "not_imp_not_urgent":  this.priority_of_ticket == 'not_imp_not_urgent' ? true : false,
                    "not_imp_urgent":  this.priority_of_ticket == 'not_imp_urgent' ? true : false,
                },
                approvers_list: this.approvers_data.map(x => x.id),
                attach_files: this.attachments,
                description: this.description,
                subject: this.subject,
                template_data: this.template_details,
                ticket_template: this.ticketType._id
            }
        },
        create_multi_json(){
            let temp_template_details = []
            this.template_details.forEach((x, x_index) => {
                if(x_index == 0 || (!this.is_approvers_mandatory && x_index > 0)){
                    temp_template_details.push(x)
                }
            })
            return{
                assignment_details: {
                    id: this.assignedTo == 'unassigned' ? '' : this.assignedCustomer.id || '',
                    is_assigned: this.assignedTo == 'unassigned' ? false : true,
                    to: this.assignedTo
                },
                eisenhower_matrix:{
                    "imp_not_urgent": this.priority_of_ticket == 'imp_not_urgent' ? true : false,
                    "imp_urgent":  this.priority_of_ticket == 'imp_urgent' ? true : false,
                    "not_imp_not_urgent":  this.priority_of_ticket == 'not_imp_not_urgent' ? true : false,
                    "not_imp_urgent":  this.priority_of_ticket == 'not_imp_urgent' ? true : false,
                },
                is_send_for_review: this.is_approvers_mandatory,
                approvers_list: this.approvers_data.map(x => x.id),
                attach_files: this.attachments,
                description: this.description,
                subject: this.subject,
                template_data: temp_template_details,
                ticket_template: this.ticketType._id
            }
        },
        searchTemplate(){
            return debounce(this.searchTemplateDebouncer, 500)
        },
        searchTemplateApiDD(){
            return debounce(this.searchTemplateApiDDDebouncer, 500)
        },
        searchApiDD(){
            return debounce(this.searchApiDDDebouncer, 500)
        },
        getAllAssignTo(){
            return debounce(this.getAllAssignToDebouncer, 500)
        },
        watchApprovers(){
            let temp_approvers_options = this.approvers_options.map(x => x.id)
            let temp_approvers_data = this.approvers_data.map(x => x.id)
            return temp_approvers_options.length == temp_approvers_data.length
        }
    },
    mounted(){
        if(this.$route.params.id) {
            this.ticket_template_type = "service";
            this.getParentTicketData();
        }
    },
    created(){
        // this.searchTemplate = debounce(this.searchTemplateDebouncer, 500)
        // this.searchTemplateApiDD = debounce(this.searchTemplateApiDDDebouncer, 500)
        // this.searchApiDD = debounce(this.searchApiDDDebouncer, 500)
        // this.getAllAssignTo = debounce(this.getAllAssignToDebouncer, 500)
        const dict = {
            custom: {
                customer:{
                    required:() => "Customer is Required",
                },
                vendor:{
                    required:() => "Vendor is Required",
                },
                subject:{
                    required:() => "Ticket Subject is Required",
                },
                department:{
                    required:() => "Department is Required",
                },
                assigned:{
                    required:() => "Assigned to is Required",
                },
                ticketType:{
                    required:() => "Ticket Template is Required"
                },
                branch_name:{
                    required:() => "Branch Name is Required"
                },
            }
        }
        this.$validator.localize("en", dict);
    },
}
</script>
<style scoped>
.activeDetails{
    background-color: #00448f !important;
    color: #fff !important;
    width: 200px !important;
    border-radius: 14px !important;
    height: 40px !important;
    font-weight: 500 !important;
    text-transform: none;
    font-size: 16px !important;
}
.boxHeader{
    background: #005dae;
    color: #fff;
    padding: 5px 25px;
    font-weight: 500;
    font-size: 14px;
}
.boxShadow{
    box-shadow: 0px 0.5px 7px 2px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    border-radius: 8px;
}
.vendor_type span{
    margin-left: 10px;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #000000;
}
.btn-blue{
    background: #005dae;
    color: #fff;
}
.ticket_decription{
    border: 1px solid #707070;
    border-radius: 10px;
    margin-left: 10px;
}
.ticket_decription .quillWrapper .ql-toolbar.ql-snow .ql-formats:nth-child(8){
    display: none !important;
}
.decription{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 8px 25px;
    font-size: 14px;
    font-weight: 600;
    border-bottom: 1px solid #303031;
}
.dlt_descs{
    float: right;
    position: relative;
    bottom: 30px;
    right: 10px;
}
.btn-upload {
    /* background: #00448b; */
    border-radius: 15px !important;
    text-transform: none !important;
    padding: 6px 18px !important;
    font-weight:500 !important;
}
.btn-upload-disabled{
    background: #e8e8e8 !important;
    border-radius: 15px !important;
    text-transform: none !important;
    padding: 6px 18px !important;
    font-weight:500 !important;
}
.attachment-bg-new{
    /* border: 1px solid #005dae !important; */
    background: transparent !important;
    width: 100%;
}
.file-bg{
    background-color: #f0f3f5;
    padding: 5px;
    border-radius: 2px;
}
._wizardBox{
    background-color: #f4f9ff;
    border: #005dae;
    width: 50%;
    height: 100px;
    padding: 10px;
    position: relative;
    left: 25%;
}
#progressbar {
    margin-bottom: 10px;
    overflow: hidden;
    color: #303031;
    width: 100%;
    display: flex;
    margin: 0;
    padding: 0;
    align-items: center;
    justify-content: center;
}

#progressbar .active {
    color: #303031
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 33%;
    position: relative;
    text-align: center;
}
#progressbar li strong {
    display: block;
    opacity: 0.5;
}

#progressbar li strong.active {
    opacity: 1;
}

#progressbar li img {
    position: relative;
    z-index: 2;
}
#progressbar li:before {
    content: '';
    width: 100%;
    border-top: dashed 2px #cdcdcd;
    position: absolute;
    left: -50%;
    top: 27px;
    z-index: 1
}
#progressbar li:first-child::before{
    width: 0% !important;
}
#progressbar li.active:before {
    border-top: solid 2px #005dae;
}
.inputLabel {
    margin-left: 6px;
}
.jobHide{
    margin-top: 14px !important;
}
.page-layout.blank {
    overflow: inherit;
}

.desc-editor{
    background: transparent;
    color: #303031;
    font-size: 14px !important;
    display: block;
    width: 100%;
    border-radius: 5px;
    border: solid 1px #3f3f3f!important;
    background: transparent !important;
    font-weight: 500;
    border-radius: 5px !important;
}
.bord-left .mx-input{
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
}
.mx-input {
    display: inline-block;
    width: 100%;
    height: 34px;
    padding: 6px 30px;
    padding-left: 10px;
    font-size: 14px;
    line-height: 1.4;
    color: #555;
    background: #f1f1f1 !important;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.diginewhelp-multiselect {
    color: #130e0e !important;
    opacity: 0.5 !important;
}
.gps-logo{
    border-radius: 5px;
    padding: 5px;
    border: 1px solid rgb(0, 0, 0);
    position: relative;
    top: -11px;
    margin-left: 5px;
}
.color-blue{
    color: #005dae;
}
.text-grey{
    color: #656565;
}
.filterSelectedName{
    position: relative;
    top:3px;
}
.filterSelectedName1{
    position: relative;
    top:0px;
}
.w-150{
    width: 150px !important;
}
.word-wrap{
    word-break: break-all !important;
    white-space: pre-wrap;
}
.h-100{
    height: 100% !important;
}
.dynamic-section{
    /* background-color: rgba(0, 0, 0, 0.05) !important; */
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
    border-radius: 6px !important;
}
.dynamic-section .table-content .table-content-data thead tr th{
    background-color: #0d84f2;
}
.dynamic-section .table-content .table-content-data tbody tr td{
    background-color: #cce3fc;
}
.infoHeader>.descriptionheader .description-text-header-right img{
    width: 23px !important;
}
.approved-btn{
    background-color: #40ad5c;
}
.rejected-btn{
    background-color: #F44336 !important;
}
.approved-btn, .rejected-btn{
    width:92px !important;
    padding: 5px 10px;
    border-radius: 5px !important;
    color: #fff;
    text-align: center;
}
.filter-multiple .custom__tag {
    background: #81aee6;
    color: #fff;
    padding: 2px 8px !important;
    border-radius: 20px;
    margin-right: 5px !important;
    display: inline-block;
    margin-bottom: 5px !important;
}

.filter-multiple .custom__tag1 {
    background: #f1f1f1;
    color: #130e0e;
    padding: 4px 8px !important;
    border-radius: 20px;
    margin-right: 5px !important;
    display: inline-block;
    margin-bottom: 5px !important;
}

.filter-multiple .custom__tag .custom__remove i {
    position: relative;
    top: -3px;
    right: -3px;
}
.filter-multiple .custom__tag1 .custom__remove i {
    position: relative;
    top: 0px;
    right: -3px;
}
.bg-grey{
    background-color: rgba(0,0,0,0.06) !important;
}

.inverse div{
     position: absolute;
     top: 27px;
     width: 11px;
     height: 11px;
     border-radius: 50%;
     background: #fff;
     animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.h-100{
    height: 100% !important;
}
.position-absolute{
     position: absolute !important;
}
.cursor-notallowed{
    cursor: not-allowed !important
}
.text-align-left{
    text-align: left;
}
.w-90{
    width: 90px !important;
}
.w-130{
    width: 130px !important
}
.w-140{
    width: 140px !important;
}
.text-grey{
    color: #abaaac;
}
.bg-grey-box{
    background: #f1f3f4
}
.dotted-grey{
    border: dotted 2px #89898d;
}
.no-att-msg{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: rgba(59, 77, 92, 0.16);
}
.browse-box{
    height: 200px;
}
.choose-file{
    border-radius: 5px !important;
}
.fs-15px{
    font-size: 15px !important
}
.mx-width-220{
    max-width: 285px !important;
}
@media screen and (max-width: 768px) {
    .p-med-12{
        padding-left: 12px !important;
        padding-right: 12px !important;
        padding-top: 12px;
    }
    .pl-med-12{
        padding-left: 12px !important;
    }
    .justify-center-frsm{
        justify-content: center;
    }
}
.paste-input::placeholder{
    font-weight: 400 !important;
} 
.breadcrumbnewtheme{
    display: flex;
    align-items: center;
    gap: 1rem;
}
.header-bottom{
    border-bottom: 1px solid #636e71;
}
.breadcrumbnewtheme div{
    color: #00448b;
}
.fs-2rem{
    font-size: 2rem;
}
.position-content-main{
    border-radius: 14px;
    background-color: #f0ddb7;
}
.header-color{
    color: #4e4e4e !important;
}
.color-light-blue{
    color: #0066d0;
}
.general-box{
    background: white;
    border-radius: 10px;
}
.eisen-matrix{
    width:240px;
    height: 120px;
    display: flex;
    align-items: center;
    padding-left:20px
}
.eisen-matrix.top-left{
    border-right: .5px solid #242629;
    border-bottom: .5px solid #242629;
}
.eisen-matrix.bottom-left{
    border-right: .5px solid #242629;
    border-top: .5px solid #242629;
}
.eisen-matrix.top-right{
    border-left: .5px solid #242629;
    border-bottom: .5px solid #242629;
}
.eisen-matrix.bottom-right{
    border-left: .5px solid #242629;
    border-top: .5px solid #242629;
}
</style>